import React, { Component } from 'react'

import { withRouter } from 'react-router-dom'
import moment from 'moment';
import 'moment/locale/pt-br'; // Importe o idioma desejado
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import FullCalendar from '@fullcalendar/react';
import { OverlayPanel } from 'primereact/overlaypanel';
import dayGridPlugin from '@fullcalendar/daygrid';
import { Panel } from 'primereact/panel';
import { Tooltip } from 'primereact/tooltip';
import timegridPlugin from '@fullcalendar/timegrid';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import interactionPlugin from '@fullcalendar/interaction';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox'
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea'
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { uniqueId } from "lodash"
import filesize from 'filesize'
import { Chart } from 'primereact/chart';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import GaugeChart from "react-gauge-chart";
import { Steps } from 'primereact/steps';
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList'
import AtividadeService from '../../app/service/AtividadeService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import ProcessoService from '../../app/service/ProcessoService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'
import UploadAtividadeService from '../../app/service/UploadAtividadeService'
import GraficoAtividadeService from '../../app/service/GraficoAtividadeService'
import UsuarioService from '../../app/service/UsuarioService'
import StatusAtividadeService from '../../app/service/StatusAtividadeService'
import FaseTarefaService from '../../app/service/FaseTarefaService'
import FaseService from '../../app/service/FaseService'
import TituloAtividadeFaseService from '../../app/service/TituloAtividadeFaseService'
import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import AgendaService from '../../app/service/AgendaService'
import PontuacaoUsuarioService from '../../app/service/PontuacaoUsuarioService'
import CheckListAtividadeService from '../../app/service/CheckListAtividadeService'
import ExecucaoCheckListService from '../../app/service/ExecucaoCheckListService'
import FinanceiroService from '../../app/service/FinanceiroService'

import NavBar from '../../componentes/Navbar'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './painel.css'
import './calendario.css'

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.atividadeService = new AtividadeService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.processoService = new ProcessoService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.uploadAtividadeService = new UploadAtividadeService();
    this.graficoAtividadeService = new GraficoAtividadeService();
    this.usuarioService = new UsuarioService();
    this.statusAtividadeService = new StatusAtividadeService();
    this.faseTarefaService = new FaseTarefaService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.tituloAtividadeFaseService = new TituloAtividadeFaseService();
    this.agendaService = new AgendaService();
    this.pontuacaoUsuarioService = new PontuacaoUsuarioService();
    this.checkListAtividadeService = new CheckListAtividadeService();
    this.execucaoCheckListService = new ExecucaoCheckListService();
    this.faseService = new FaseService();
    this.financeiroService = new FinanceiroService();
 
    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.acoesHistoricoUsuario = this.acoesHistoricoUsuario.bind(this);
    this.acoesHistorico = this.acoesHistorico.bind(this);
    this.acceptExcluirHistorico = this.acceptExcluirHistorico.bind(this);
    this.onChangeStatusAtividade = this.onChangeStatusAtividade.bind(this);
    this.renderFooterProcesso = this.renderFooterProcesso.bind(this);
    this.acoesProcesso = this.acoesProcesso.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.onMudancaData = this.onMudancaData.bind(this);
    this.acoesAtividadeConsultaCalendario = this.acoesAtividadeConsultaCalendario.bind(this);
    this.acoesAtividadeConsultaCalendarioProcesso = this.acoesAtividadeConsultaCalendarioProcesso.bind(this);
    this.prazoFatal = this.prazoFatal.bind(this);
    this.template = this.template.bind(this);
    this.templateKanban = this.templateKanban.bind(this);
    this.templateMniniAgenda = this.templateMniniAgenda.bind(this);
    this.onGrauChange = this.onGrauChange.bind(this);
    this.onImportante = this.onImportante.bind(this);
    this.grauTemplate = this.grauTemplate.bind(this);

    this.state = {
      atividadesAtrasadasResponsavelList: [],
      quantidadeAtividadesAtrasadas: '0',
      atividadesHojeResponsavelList: [],
      quantidadeAtividadesHoje: '0',
      atividadesSeteResponsavelList: [],
      quantidadeAtividadesSete: '0',
      atividadesTrintaResponsavelList: [],
      quantidadeAtividadesTrinta: '0',
      quantidadeTotalResponsavel: '0',

      atividadesAtrasadasInterssadosList: [],
      quantidadeAtrasadosInteressados: '0',
      atividadesHojeInteressadosList: [],
      quantidadeHojeInteressados: '0',
      atividadesSeteInteressadosList: [],
      quantidadeSeteInteressados: '0',
      atividadesTrintaInteressadosList: [],
      quantidadeTrintaInteressados: '0',
      quantidadeTotalInteressados: '0',

      compromissosAtrasadosList: [],
      quantidadeAtrasadadosCompromissos: '0',
      compromissosHojeList: [],
      quantidadeHojeCompromissos: '0',
      compromissosSeteList: [],
      quantidadeSeteCompromissos: '0',
      compromissosTrinta: [],
      quantidadeTrintaCompromissos: '0',
      quantidadeTotalCompromissos: '0',

      pontuacao: '',
      pesquisaAtividade: '',
      exibeOcorrenciasEncontradas: 'none',
      ocorrenciasEncontradas: '',

      openSpinner: false,

      descricaoStatus: '',

      layout: 'grid',
      //Alterar Atividade
      atividade: null,
      codigo: '',
      titulo: '',
      //Atividade Customizada
      grupoTrabalhoDescricao: '',
      subGrupoTrabalhoDescricao: '',
      codigoProcesso: '',
      codigoSubGrupo: '',
      codigoGrupo: '',
      statusCodigo: '',
      dataLimiteAntiga: '',
      horaAntiga: '',
      pontuacao: '',
      descricao: '',
      usuarioCriouAtividade: '',
      dataRegistroAtividade: '',
      dtLimite: '',
      dtFatal: '',
      tipo: '',
      status: null,
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      displayDescricao: false,
      tipoAtividade: null,
      grupos: [],
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      responsaveis: [],
      responsavel: null,
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      processos: [],
      processo: null,
      bloqueiaGrupo: false,
      optionStatus: null,
      responsaveisLista: [],
      quantidadeResponsaveis: '',
      interessadosLista: [],
      quantidadeInteressados: '',
      detail: '',
      processos: [],
      partes: '',
      favorito: '',
      titleFavorito: '',
      exibirFavorito: '',
      importante: '',
      titleImportante: '',
      exibirImportanteEmpresa: '',
      statusAtividade: [],
      selectStatusAtividade: null,
      codigoPessoa: '',
      pessoaNome: '',

      campoPesquisaProcesso: '',
      processoPesquisadoVisivel: '',
      processoPesquisado: '',
      
      //Histórico
      historico: [],
      registroHistorico: null,
      displayHistorico: null,
      dsHistorico: '',
      displayHistoricoIncluir: false,
      visibleHistorico: false,
      //Arquivos Anexados
      exibirLinkAnexo: 'none',
      displayArquivosAnexados: false,
      upLoadFiles: [],
      nome: '',
      dsArquivo: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      //Graficos dos painés
      graficoStatus: [],
      graficoStatusData: null,
      //Estatística do usuário
      atividadesCriadasUsuario: '',
      atividadesUltimosTrintaDias: '',
      atividadesUltimosTrintaDiasConcluidas: '',
      atividadesUltimosTrintaDiasConcluidasAtrasadas: '',
      atividadesUltimosTrintaDiasConcluidosNoPrazo: '',
      //Kannban
      kanbanCriada: [],
      kanbanCriadaLabel: '',
      kanbanCriadaExibir: '',

      kanbanAtivo: [],
      kanbanAtivoLabel: '',
      kanbanAtivoExibir: '',

      kanbanFazendo: [],
      kanbanFazendoLabel: '',
      kanbanFazendoExibir: '',

      kanbanAguardando: [],
      kanbanAguardandoLabel: '',
      kanbanAguardandoExibir: '',

      kanbanCiente: [],
      kanbanCienteLabel: '',
      kanbanCienteExibir: '',

      kanbanConcluido: [],
      kanbanConcluidoLabel: '', 
      kanbanConcluidoExibir: '',

      //Filtros Kanban
      usuariosKanban: [],
      selectUsuariosKanban: [],
      gruposKanban: [],
      selectGruposKanban: [],
      dataKanbanInicial: null,
      dataKanbanFinal: null,
      tabAtivo: 0,
      totalCriada: '',
      totalAtivos: '',
      totalFazendo: '',
      totalAguardando: '',
      totalCiente: '',
      paramProcessoPrincipal: '',
      mudancaDataHistorico: [],
      //Fases da Atividade
      fases: [],
      fase: null,
      faseNome: '',
      tituloAtividade: null,
      tituloAtividadeCodigo: '',
      //Mine Agenda
      agenda: [],
      //Lista de atividades
      atividadesLista: [],
      exibirAtividades: 'none',
      dataFiltroAgenda: '',
      //Pontuação Usuario
      desempenhoUsuario: null,
      optionsChart: null,
      selectedDate: null,
      mesMiniAgenda: null,
      descricaoMes: '',
      anoMiniAgenda: null,
      modalAlterarMiniAgenda: false,
      //Consultas da Mini Agenda
      dataMiniAgenda: '',
      dataLimiteInicialMiniAgenda: '',
      dataLimiteFinalMiniAgenda: '',
      prazoFatalInicialMiniAgenda: '',
      prazoFatalFinalMiniAgenda: null,
      dataConclusaoInicialMiniAgenda: '',
      dataConclusaoFinalMiniAgenda: '',
      financeiroMiniAgenda: null,
      importanteMiniAgenda: null,
      urgenteMiniAgenda: null,
      tipoUsuarioMiniAgenda: null,
      prazoFatalMiniAgenda: null,
      statusMiniAgenda: null,
      faseMiniAgenda: null,
      partesMiniAgenda: '',
      processoMiniAgenda: '',
      classificacaoMiniAgenda: null,
      ordenacaoMiniAgenda: null,
      modalFiltroAtividades: false,
      statusMiniAgenda: null,
      statusListaMiniAgenda: [],
      grau: [],
      grauFiltro: [],
      //Checklist
      checkList: [],
      activeIndex: '',
      execucaoCheckList: null,
      modalCheckList: false,
      usuarioCheckList: '',
      dataExecucaoCheckList: '',
      statusExecucao: '',
      //Atividades com pessoas
      pessoa: null,
      campoPessoaPesquisada: 'none',
      pessoaPesquisada: '',
      //Financeiro
      modalLancamento: false,
      valorLancamento: '',
      valorLancamentoPago: '',
      isLancamento: 'false',
      categoriaLancamento: '',
      lancamento: null,
      tipoLancamento: '',
      dataVencimentoLancamento: '',
      dataPagamentoLancamento: '',
      linkLancamento: 'none',
      //Experimento
      date: '',
      mesCalendario: '',
      anoCalendario: '',
      primeiroDia: '',
      ultimoDia: '',
      diasCalendario: []
    };

    this.itensCheckList = [];

    this.classificacoes = [
      {codigo: 1, nome: 'Título da Atividade'},
      {codigo: 2, nome: 'Data limite'},
      {codigo: 3, nome: 'Prazo Fatal'},
      {codigo: 4, nome: 'Fase Processual'}
    ];

    this.prazosFatais = [
      {codigo: 'true', nome: 'Sim'},
      {codigo: 'false', nome: 'Não'}
    ]

    this.ordenacoes = [
      {codigo: 'ASC', nome: 'Ascendente'},
      {codigo: 'DESC', nome: 'Decrescente'}
    ]

    this.meses = [
      {mes: 1, nome: 'Janeiro'},
      {mes: 2, nome: 'Fevereiro'},
      {mes: 3, nome: 'Março'},
      {mes: 4, nome: 'Abril'},
      {mes: 5, nome: 'Maio'},
      {mes: 6, nome: 'Junho'},
      {mes: 7, nome: 'Julho'},
      {mes: 8, nome: 'Agosto'},
      {mes: 9, nome: 'Setembro'},
      {mes: 10, nome: 'Outubro'},
      {mes: 11, nome: 'Novembro'},
      {mes: 12, nome: 'Dezembro'}
    ];

    this.ano = [
      {ano: 2021, nome: 2021},
      {ano: 2022, nome: 2022},
      {ano: 2023, nome: 2023},
      {ano: 2024, nome: 2024},
      {ano: 2025, nome: 2025},
      {ano: 2026, nome: 2026},
    ];

    this.prazosFatais = [
      {codigo: 'true', nome: 'Sim'},
      {codigo: 'false', nome: 'Não'}
    ];

    this.financeiro = [
      {codigo: 'true', nome: 'Sim'},
      {codigo: 'false', nome: 'Não'}
    ];

    this.tipoUsuario = [
      {codigo: 'R', nome: 'Responsável'},
      {codigo: 'I', nome: 'Interessado'}
    ]

    this.importante = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ]

    this.urgente = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ]

    this.options = this.getLightTheme();
    this.lightOptions = {
      aspectRatio: .8,
      plugins: {
          legend: {
              labels: {
                  
              }
          }
      }
    };

    this.horizontalOptions = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      aspectRatio: .8,
      plugins: {
          legend: {
              labels: {
                  color: '#495057'
              }
          }
      },
      scales: {
          x: {
              ticks: {
                  color: '#495057'
              },
              grid: {
                  color: '#ebedef'
              }
          },  
          y: {
              ticks: {
                  color: '#495057'
              },
              grid: {
                  color: '#ebedef'
              }
          }
      }
  };
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let horizontalOptions = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      aspectRatio: .8,
      plugins: {
          legend: {
              labels: {
                  color: '#495057'
              }
          }
      },
      scales: {
          x: {
              ticks: {
                  color: '#495057'
              },
              grid: {
                  color: '#ebedef'
              }
          },
          y: {
              ticks: {
                  color: '#495057'
              },
              grid: {
                  color: '#ebedef'
              }
          }
      }
    };

    return {
        basicOptions,
        horizontalOptions
    };
  }

  diasCalendario = async (mes,ano) => {
    await this.atividadeService.diasCalendario(mes,ano)
      .then(response => {
        this.setState({mesCalendario: mes});
        this.setState({anoCalendario: ano});
        this.setState({diasCalendario: response.data});

        let menorNumero = response.data[0].dia;
        let maiorNumero = response.data[0].dia;

        for (let i = 1; i < response.data.length; i++) {
          if (response.data[i].dia < menorNumero) {
            menorNumero = response.data[i].dia;
          }
          if (response.data[i].dia > maiorNumero) {
            maiorNumero = response.data[i].dia;
          }
        }
        this.setState({primeiroDia: menorNumero});
        this.setState({segundoDia: maiorNumero});
      }).catch(error => {
        console.log(error);
      })
  }

  gerarPontuacaoUsuario = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    const dataAtual = new Date();

    const anoAtual = dataAtual.getFullYear();
    const mesAtual = dataAtual.getMonth() + 1; // Adicione 1 para obter o mês atual
    const mesAnterior = mesAtual === 1 ? 12 : mesAtual - 1;
    const documentStyle = getComputedStyle(document.documentElement);
    await this.pontuacaoUsuarioService.gerarPontuacaoUsuario(anoAtual,mesAtual,mesAnterior,
      usuarioLogado.codigo, usuarioLogado.empresa.codigo)
        .then(response => {
          //this.setState({desempenhoUsuario: response.data});
          const dias = [];
          for(let i = 0; i < response.data.projecao.length; i++) {
            dias.push(response.data.projecao[i].dias);
          }
          let datasets = [];
          let pontosAnterior = [];
          for(let i = 0; i < response.data.mesAnterior.length; i++) {
            pontosAnterior.push(response.data.mesAnterior[i].pontos);
          }
          const mesAnterior = {
            label: 'Mês Anterior',
            data: pontosAnterior,
            fill: false,
            tension: 0.4,
            borderColor: documentStyle.getPropertyValue('--orange-500'),
            backgroundColor: 'rgba(255,255,255,0.3)'
          }
          datasets.push(mesAnterior);

          let pontosAtual = [];
          for(let i = 0; i < response.data.mesAtual.length; i++) {
            pontosAtual.push(response.data.mesAtual[i].pontos);
          }

          const mesAtual = {
            label: 'Mês Atual',
            data: pontosAtual,
            fill: true,
            borderDash: [5, 5],
            tension: 0.4,
            borderColor: documentStyle.getPropertyValue('--blue-500'),
            backgroundColor: 'rgba(255,255,255,0.3)'
          }
          datasets.push(mesAtual);

          let pontosProjecao = [];
          for(let i = 0; i < response.data.projecao.length; i++) {
            pontosProjecao.push(response.data.projecao[i].pontos);
          }

          const projecao = {
            label: 'Meta',
            data: pontosProjecao,
            fill: true,
            borderColor: documentStyle.getPropertyValue('--green-500'),
            tension: 0.4,
            backgroundColor: 'rgba(255,255,255,0.3)'
          }
          datasets.push(projecao);
          
          const data = {
            labels: dias,
            datasets: datasets
          };

          this.setState({desempenhoUsuario: data});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'warn', summary: 'Pontuação Usuários', detail:`${this.state.detail}`, life: 4000});
        });

  }

  onMudancaData(e) {
    let selectedCities = [...this.state.mudancaDataHistorico];

    if (e.checked)
        selectedCities.push(e.value);
    else
        selectedCities.splice(selectedCities.indexOf(e.value), 1);

    this.setState({ mudancaDataHistorico: selectedCities });
  }

  listarFases = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade', life: 4000});
      })
  }

  listarFasesPorTitulo = async (titulo) => {
    await this.tituloAtividadeFaseService.listar(titulo.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade por Título', life: 4000});
      })
  }

  consultarTituloAtividadePorNome = async (nome) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.consultarPorNome(nome, usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tituloAtividade: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Título da Atividade pelo nome', life: 4000});
      })
  }

  listarStatusAtividade = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusAtividade: response.data});
        this.setState({statusMiniAgenda: response.data});
        for(let i = 0; i < response.data.length; i++) {
          if(response.data[i].status == 'Criada') {
            this.setState({kanbanCriadaLabel: response.data[i].status});
            //this.setState({kanbanAtivoExibir: response.data[0].exibir});
          } else if(response.data[i].status == 'Ativo') {
            this.setState({kanbanAtivoLabel: response.data[i].status});
          } else if(response.data[i].status == 'Fazendo') {
            this.setState({kanbanFazendoLabel: response.data[i].status});
          } else if(response.data[i].status == 'Concluído') {
            this.setState({kanbanConcluidoLabel: response.data[i].status});
          }
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
  }

  listarStatusAtividadeConsulta = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusAtividade: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
  }

  //Kanban
  usuariosKanban = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.perfil.codigo == 1) {
      await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
        .then(response => {
          this.setState({usuariosKanban: response.data});
          this.setState({selectUsuariosKanban: response.data});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Lista de usuários por empresa', detail:`${this.state.detail}`, life: 4000});
        })
    } else {
      await this.usuarioService.listarUsuariosEmpresaFiltrado(usuarioLogado.codigo)
        .then(response => {
          this.setState({usuariosKanban: response.data});
          this.setState({selectUsuariosKanban: response.data});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Lista de usuários por empresa', detail:`${this.state.detail}`, life: 4000});
        })
    }
  }

  gruposKanban = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoTrabalhoService.listarGruposUsuario2(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposKanban: response.data});
        this.setState({selectGruposKanban: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Trabalho por Usuário', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanban = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var codigosUsuarios = '';
    if(this.state.selectUsuariosKanban != null) {
      var contador = 0;
      var tamanhoLista = this.state.selectUsuariosKanban.length;
      for(let i = 0; i < this.state.selectUsuariosKanban.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosUsuarios = codigosUsuarios + this.state.selectUsuariosKanban[i].codigo + ",";
        } else {
          codigosUsuarios = codigosUsuarios + this.state.selectUsuariosKanban[i].codigo;
        }

        contador++;
      }
    };

    var codigosGrupos = '';
    if(this.state.selectGruposKanban != null) {
      var contador = 0;
      var tamanhoLista = this.state.selectGruposKanban.length;
      for(let i = 0; i < this.state.selectGruposKanban.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosGrupos = codigosGrupos + this.state.selectGruposKanban[i].codigo + ",";
        } else {
          codigosGrupos = codigosGrupos + this.state.selectGruposKanban[i].codigo;
        }

        contador++;
      }
    };
 
    //Datas de filtro
    var dataInicial = null;
    var dataFinal = null;
    if(this.state.dataKanbanInicial != null && this.state.dataKanbanFinal != null) {
      //Data inicial
      var dateInicial = this.state.dataKanbanInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataKanbanFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataFinal =  year+"-"+month+"-"+day;
    };

    const filtroCriada = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 'Criada',
      limite: 100
    };
    await this.consultarKanbanCriada(filtroCriada);

    const filtroAtivo = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 'Ativo',
      limite: 100
    };
    await this.consultarKanbanAtivo(filtroAtivo);

    const filtroAguardando = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 'Aguardando',
      limite: 100
    };
    //await this.consultarKanbanAguardando(filtroAguardando);

    const filtroCiente = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 'Ciente',
      limite: 100
    };
    //await this.consultarKanbanCiente(filtroCiente);

    const filtroConcluido = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 'Concluído',
      limite: 100
    };
    await this.consultarKanbanConcluido(filtroConcluido);

    const filtroFasendo = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 'Fazendo',
      limite: 100
    };
    await this.consultarKanbanFazendo(filtroFasendo);

  }

  consultarKanbanCriada = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanCriada: response.data});
        this.setState({totalCriada: response.data.length});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Criada', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanAtivo = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanAtivo: response.data});
        this.setState({totalAtivos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Ativo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanAguardando = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanAguardando: response.data});
        this.setState({totalAguardando: response.data.length});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Aguardando', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanCiente = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanCiente: response.data});
        this.setState({totalCiente: response.data.length});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Ciente', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanConcluido = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanConcluido: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Concluido', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanFazendo = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanFazendo: response.data});
        this.setState({totalFazendo: response.data.length})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Fazendo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  graficoAtividadeUsuario = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.graficoAtividadeService.graficoAtividadeStatusUsuarioPainel(usuarioLogado.codigo)
      .then(response => {
        this.setState({graficoStatus: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grafico Atividade Usuário', detail:`${this.state.detail}`, life: 4000});
      });

      let status = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        status.push(this.state.graficoStatus[i].status);
      }

      let totais = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        totais.push(this.state.graficoStatus[i].total);
      }

      let cores = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        cores.push(this.state.graficoStatus[i].cor);
      }


      await this.setState({graficoStatusData: {
        labels: status,
        datasets: [
          {
            data: totais,
            backgroundColor: cores,
          }
        ]
      }});
  }

  atividadesAtrasadasResponsavel = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    var importante = null;
    var urgente = null;
    var fatal = null;
    if(this.state.grauFiltro.length > 0) {
      for(let i = 0; i < this.state.grauFiltro.length; i++) {
        if(this.state.grauFiltro[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grauFiltro[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grauFiltro[i] == 'fatal') {
          fatal = 'S';
        }
      }
    }

    await this.atividadeService.atividadesAtrasadasResponsavel(usuarioLogado.codigo,this.state.pesquisaAtividade,importante,urgente,fatal)
      .then(response => {
        this.setState({atividadesAtrasadasResponsavelList: response.data})
        this.setState({quantidadeAtividadesAtrasadas: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesHojeResponsavel = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    var importante = null;
    var urgente = null;
    var fatal = null;
    if(this.state.grauFiltro.length > 0) {
      for(let i = 0; i < this.state.grauFiltro.length; i++) {
        if(this.state.grauFiltro[i] == 'importante') {
          importante = 'S'
        }

        if(this.state.grauFiltro[i] == 'urgente') {
          urgente = 'S'
        }

        if(this.state.grauFiltro[i] == 'fatal') {
          fatal = 'S';
        }
      }
    }
    await this.atividadeService.atividadesHojeResponsavel(usuarioLogado.codigo, this.state.pesquisaAtividade,importante,urgente,fatal)
      .then(response => {
        this.setState({atividadesHojeResponsavelList: response.data});
        this.setState({quantidadeAtividadesHoje: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesSeteResponsavel = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var importante = null;
    var urgente = null;
    var fatal = null;
    if(this.state.grauFiltro.length > 0) {
      for(let i = 0; i < this.state.grauFiltro.length; i++) {
        if(this.state.grauFiltro[i] == 'importante') {
          importante = 'S'
        }

        if(this.state.grauFiltro[i] == 'urgente') {
          urgente = 'S'
        }

        if(this.state.grauFiltro[i] == 'fatal') {
          fatal = 'S';
        }
      }
    }
    await this.atividadeService.atividadesSeteResponsavel(usuarioLogado.codigo, this.state.pesquisaAtividade,importante,urgente,fatal)
      .then(response => {
        this.setState({atividadesSeteResponsavelList: response.data});
        this.setState({quantidadeAtividadesSete: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesTrintaResponsavel = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var importante = null;
    var urgente = null;
    var fatal = null;
    if(this.state.grauFiltro.length > 0) {
      for(let i = 0; i < this.state.grauFiltro.length; i++) {
        if(this.state.grauFiltro[i] == 'importante') {
          importante = 'S'
        }

        if(this.state.grauFiltro[i] == 'urgente') {
          urgente = 'S'
        }

        if(this.state.grauFiltro[i] == 'fatal') {
          fatal = 'S';
        }
      }
    }
    await this.atividadeService.atividadesTrintaResponsavel(usuarioLogado.codigo, this.state.pesquisaAtividade,importante,urgente,fatal)
      .then(response => {
        this.setState({atividadesTrintaResponsavelList: response.data});
        this.setState({quantidadeAtividadesTrinta: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesAtrasadasInteressados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var importante = null;
    var urgente = null;
    var fatal = null;
    if(this.state.grauFiltro.length > 0) {
      for(let i = 0; i < this.state.grauFiltro.length; i++) {
        if(this.state.grauFiltro[i] == 'importante') {
          importante = 'S'
        }

        if(this.state.grauFiltro[i] == 'urgente') {
          urgente = 'S'
        }

        if(this.state.grauFiltro[i] == 'fatal') {
          fatal = 'S';
        }
      }
    }
    await this.atividadeService.atividadesAtrasadasInteressados(usuarioLogado.codigo, this.state.pesquisaAtividade,importante,urgente,fatal)
      .then(response => {
        this.setState({atividadesAtrasadasInteressadosList: response.data});
        this.setState({quantidadeAtrasadosInteressados: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesHojeInteressados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var importante = null;
    var urgente = null;
    var fatal = null;
    if(this.state.grauFiltro.length > 0) {
      for(let i = 0; i < this.state.grauFiltro.length; i++) {
        if(this.state.grauFiltro[i] == 'importante') {
          importante = 'S'
        }

        if(this.state.grauFiltro[i] == 'urgente') {
          urgente =
           'S'
        }

        if(this.state.grauFiltro[i] == 'fatal') {
          fatal = 'S';
        }
      }
    }
    await this.atividadeService.atividadesHojeInteressados(usuarioLogado.codigo, this.state.pesquisaAtividade,importante,urgente,fatal)
      .then(response => {
        this.setState({atividadesHojeInteressadosList: response.data});
        this.setState({quantidadeHojeInteressados: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesSeteInteressados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var importante = null;
    var urgente = null;
    var fatal = null;
    if(this.state.grauFiltro.length > 0) {
      for(let i = 0; i < this.state.grauFiltro.length; i++) {
        if(this.state.grauFiltro[i] == 'importante') {
          importante = 'S'
        }

        if(this.state.grauFiltro[i] == 'urgente') {
          urgente = 'S'
        }

        if(this.state.grauFiltro[i] == 'fatal') {
          fatal = 'S';
        }
      }
    }
    await this.atividadeService.atividadesSeteInteressados(usuarioLogado.codigo,this.state.pesquisaAtividade,importante,urgente,fatal)
      .then(response => {
        this.setState({atividadesSeteInteressadosList: response.data});
        this.setState({quantidadeSeteInteressados: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesTrintaInteressados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var importante = null;
    var urgente = null;
    var fatal = null;
    if(this.state.grauFiltro.length > 0) {
      for(let i = 0; i < this.state.grauFiltro.length; i++) {
        if(this.state.grauFiltro[i] == 'importante') {
          importante = 'S'
        }

        if(this.state.grauFiltro[i] == 'urgente') {
          urgente = 'S'
        }

        if(this.state.grauFiltro[i] == 'fatal') {
          fatal = 'S';
        }
      }
    }
    await this.atividadeService.atividadesTrintaInteressados(usuarioLogado.codigo, this.state.pesquisaAtividade,importante,urgente,fatal)
      .then(response => {
        this.setState({atividadesTrintaInteressadosList: response.data});
        this.setState({quantidadeTrintaInteressados: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  compromissosAtrasados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.compromissosAtrasados(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({compromissosAtrasadosList: response.data});
        this.setState({quantidadeAtrasadosCompromissos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  compromissosHoje = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.compromissosHoje(usuarioLogado.codigo,this.state.pesquisaAtividade)
      .then(response => {
        this.setState({compromissosHojeList: response.data});
        console.log('A quantidade de compromissos', response.data.length);
        this.setState({quantidadeHojeCompromissos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  compromissosSete = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.compromissosSete(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({compromissosSeteList: response.data});
        this.setState({quantidadeSeteCompromissos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  compromissosTrinta = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.compromissosTrinta(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({compromissosTrintaList: response.data});
        this.setState({quantidadeTrintaCompromissos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  ativarKanban = async () => {
    this.setState({openSpinner: true});
    this.usuariosKanban();
    this.gruposKanban();
    this.consultarKanban();
    this.setState({openSpinner: false});
  }

  listarAgenda = async () => {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    var contador = 0;
    var tamanhoLista = this.state.gruposKanban.length;
    let codigoGrupos = '';
    for(let i = 0; i < this.state.gruposKanban.length; i++) {
      if(contador < tamanhoLista -1) {
        codigoGrupos = codigoGrupos + this.state.gruposKanban[i].codigo + ",";
      } else {
        codigoGrupos = codigoGrupos + this.state.gruposKanban[i].codigo;
      }

      contador++;
    }

    contador = 0;
    tamanhoLista = this.state.usuariosKanban.length;
    let codigosUsuarios = 0;
    if(usuarioLogado.perfil.codigo != 1) {
      codigosUsuarios = usuarioLogado.codigo;
    } else {
      for(let i = 0; i < this.state.usuariosKanban.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosUsuarios = codigosUsuarios + this.state.usuariosKanban[i].codigo + ",";
        } else {
          codigosUsuarios = codigosUsuarios + this.state.usuariosKanban[i].codigo;
        }

        contador++;
      }
    }

    contador = 0;
    tamanhoLista = this.state.statusAtividade.length;
    let codigosStatus = 0;
    for(let i = 0; i < this.state.statusAtividade.length; i++) {
      if(contador < tamanhoLista -1) {
        codigosStatus = codigosStatus + this.state.statusAtividade[i].codigo + ",";
      } else {
        codigosStatus = codigosStatus + this.state.statusAtividade[i].codigo;
      }

      contador++;
    }

    contador = 0;
    const tipos = [
      {codigo: 'A', nome: 'Compromissos/Audiências'},
      {codigo: 'T', nome: 'Prazos'}
    ];
    tamanhoLista = tipos.length;
    let codigoTipos = '';
    for(let i = 0; i < tipos.length; i++) {
      if(contador < tamanhoLista -1) {
        codigoTipos = codigoTipos + "'" + tipos[i].codigo + "',";
      } else {
        codigoTipos = codigoTipos + "'" + tipos[i].codigo + "'";
      }

      contador++;
    }

    const filtro = {
      usuario: usuarioLogado.codigo,
      usuarios: codigosUsuarios,
      grupos: codigoGrupos,
      status: codigosStatus,
      tipos: codigoTipos
    }
    await this.agendaService.consultarAgendaHomeResumo(filtro)
      .then(response => {
        this.setState({agenda: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  filtrarAtividades = async () => {
    this.setState({dataLimiteInicialMiniAgenda: ''});
    this.setState({dataLimiteFinalMiniAgenda: ''});
    this.setState({prazoFatalInicialMiniAgenda: ''});
    this.setState({prazoFatalFinalMiniAgenda: ''});
    this.setState({statusMiniAgenda: null});
    this.setState({prazoFatal: null})
    this.setState({processoMiniAgenda: ''});
    this.setState({classificacaoMiniAgenda: null});
    this.setState({ordenacaoMiniAgenda: null});
    this.setState({partesMiniAgenda: ''});
    this.setState({openSpinner: true});
    await this.listarStatusAtividade();
    await this.listarFasesProcessuais();
    this.setState({openSpinner: false});
    this.abrirModal('modalFiltroAtividades');
  }

  listarFasesProcessuais = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Fases Processuais', detail:`${error}`, life: 4000});
      })
  }

  exibirAtividades = async (rowData) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      data: rowData.event.extendedProps.img,
      dataLimiteInicial: '0',
      dataLimiteFinal: '0',
      processo: this.state.processoMiniAgenda,
      prazoFatalInicial: '0',
      prazoFatalFinal: '0',
      dataConclusaoInicial: '0',
      dataConclusaoFinal: '0',
      isFinanceiro: false,
      importante: 'T',
      urgente: 'T',
      tipoUsuario: '0',
      status: '0',
      isPrazoFatal: false,
      fase: '0',
      partes: '0',
      classificacao: 2,
      ordenacao: 'DESC'
    }
    await this.atividadeService.listarAtividadesPorDataLimite(filtro)
      .then(response => {
        this.setState({atividadesLista: response.data});
        this.setState({dataFiltroAgendaConsulta: rowData.event.extendedProps.img});
        this.setState({exibirAtividades: 'block'});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      });
      for(let i = 0; i < this.state.atividadesLista.length; i++) {
        this.setState({dataFiltroAgenda: this.state.atividadesLista[i].dtLimite});
        break;
      }
      this.setState({openSpinner: false});
  }

  faseTemplate(data) {
    if(data.fase != null) {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corfase}`}} value={data.fase}></Tag>
        </React.Fragment>
      )
    }
  }

  statusTemplate(data) {
    if(data.importante == 'S' && data.urgente == 'S') {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.status}></Tag>
          &nbsp;
          <Tag style={{backgroundColor: 'red'}} value="Urgente"></Tag>
          &nbsp;
          <Tag style={{backgroundColor: '#3B82F6'}} value="Importante"></Tag>
        </React.Fragment>
      );
    } else if(data.importante == 'S' && data.urgente == 'N') {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.status}></Tag>
          &nbsp;
          <Tag style={{backgroundColor: '#3B82F6'}} value="Importante"></Tag>
        </React.Fragment>
      );
    } else if(data.importante == 'N' && data.urgente == 'S') {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.status}></Tag>
          &nbsp;
          <Tag style={{backgroundColor: 'red'}} value="Urgente"></Tag>
        </React.Fragment>
      );
    } else {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.status}></Tag>
        </React.Fragment>
      );
    }
  }

  exibirAtividadesPorDataAgenda = async (dia) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var mes = this.state.anoMiniAgenda.ano + "-" + this.state.mesMiniAgenda.mes + "-" + dia;
    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      data: mes,
      dataLimiteInicial: '0',
      dataLimiteFinal: '0',
      processo: '0',
      prazoFatalInicial: '0',
      prazoFatalFinal: '0',
      status: '0',
      isPrazoFatal: 'false',
      classificacao: '2',
      ordenacao: 'DESC'
    }
    this.setState({openSpinner: true});
    await this.atividadeService.listarAtividadesPorDataLimite(filtro)
      .then(response => {
        this.setState({atividadesLista: response.data});
        this.setState({dataFiltroAgendaConsulta: mes});
        this.setState({exibirAtividades: 'block'});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      });
      for(let i = 0; i < this.state.atividadesLista.length; i++) {
        this.setState({dataFiltroAgenda: this.state.atividadesLista[i].dtLimite});
        break;
      }
      this.setState({openSpinner: false});
  }

  consultarAtividadesGeral = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    //Datas de filtro Data Limite
    var dataLimiteInicial = '0';
    var dataLimiteFinal = '0';
    if((this.state.dataLimiteInicialMiniAgenda != '' && this.state.dataLimiteInicialMiniAgenda != null) &&
       (this.state.dataLimiteFinalMiniAgenda != '' && this.state.dataLimiteFinalMiniAgenda != null)) {
      //Data inicial
      var dateInicial = this.state.dataLimiteInicialMiniAgenda;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataLimiteInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataLimiteFinalMiniAgenda;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataLimiteFinal =  year+"-"+month+"-"+day;
    }

    //Datas de filtro Data Prazo Fatal
    var prazoFatalInicial = '0';
    var prazoFatalFinal = '0';
    if((this.state.prazoFatalInicialMiniAgenda != '' && this.state.prazoFatalInicialMiniAgenda != null) &&
       (this.state.prazoFatalFinalMiniAgenda != '' && this.state.prazoFatalFinalMiniAgenda != null)) {
      //Data inicial
      var dateInicial = this.state.prazoFatalInicialMiniAgenda;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      prazoFatalInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.prazoFatalFinalMiniAgenda;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      prazoFatalFinal =  year+"-"+month+"-"+day;
    }

    //Datas de Filtro Conclusão
    var dataConclusaoInicial = '0';
    var dataConclusaoFinal = '0';
    if((this.state.dataConclusaoInicialMiniAgenda != '' && this.state.dataConclusaoInicialMiniAgenda != null) &&
       (this.state.dataConclusaoFinalMiniAgenda != '' && this.state.dataConclusaoFinalMiniAgenda != null)) {
      //Data inicial
      var dateInicial = this.state.dataConclusaoInicialMiniAgenda;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataConclusaoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataConclusaoFinalMiniAgenda;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataConclusaoFinal =  year+"-"+month+"-"+day;
    }

    //Define se vai filtrar apenas prazos fatais
    var isPrazoFatal = 'false';
    if(this.state.prazoFatalMiniAgenda != null) {
      isPrazoFatal = this.state.prazoFatalMiniAgenda.codigo;
    }

    //Define se vai filtrar apenas atividades do tipo financeiro
    var isFinanceiro = 'false';
    if(this.state.financeiroMiniAgenda != null) {
      isFinanceiro = this.state.financeiroMiniAgenda.codigo;
    }

    //Filtra atividades importantes
    var importante = 'T';
    if(this.state.importanteMiniAgenda != null) {
      importante = this.state.importanteMiniAgenda.codigo;
    }

    //Filtra as atividades urgentes
    var urgente = 'T';
    if(this.state.urgenteMiniAgenda != null) {
      urgente = this.state.urgenteMiniAgenda.codigo;
    }

    //Filtra por tipo de usuário (Responsável ou Interessado)
    var tipoUsuario = '0';
    if(this.state.tipoUsuarioMiniAgenda != null) {
      tipoUsuario = this.state.tipoUsuarioMiniAgenda.codigo;
    }

    //Status
    var status = '0';
    if(this.state.statusMiniAgenda != null) {
      var contador = 0;
      for(let i = 0; i < this.state.statusMiniAgenda.length; i++) {
        if(contador < this.state.statusMiniAgenda.length - 1) {
          status = status + this.state.statusMiniAgenda[i].codigo + ',';
        } else {
          status = status + this.state.statusMiniAgenda[i].codigo;
        }
        contador++;
      }
    }

    //Fase Processual
    var fase = '0';
    if(this.state.faseMiniAgenda != null) {
      fase = this.state.faseMiniAgenda.nome;
    }

    //Atividades com Prazo Fatal
    var prazoFatal = 'false';
    if(this.state.prazoFatalMiniAgenda != null) {
      prazoFatal = this.state.prazoFatalMiniAgenda.codigo;
    }

    //Classificação e Ordenação
    var classificacao = '2';
    if(this.state.classificacaoMiniAgenda != null) {
      classificacao = this.state.classificacaoMiniAgenda.codigo;
    }

    var ordenacao = 'DESC';
    if(this.state.ordenacaoMiniAgenda != null) {
      ordenacao = this.state.ordenacaoMiniAgenda.codigo;
    }

    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      data: '0',
      dataLimiteInicial: dataLimiteInicial,
      dataLimiteFinal: dataLimiteFinal,
      processo: this.state.processoMiniAgenda,
      prazoFatalInicial: prazoFatalInicial,
      prazoFatalFinal: prazoFatalFinal,
      dataConclusaoInicial: dataConclusaoInicial,
      dataConclusaoFinal: dataConclusaoFinal,
      isFinanceiro: isFinanceiro,
      importante: importante,
      urgente: urgente,
      tipoUsuario: tipoUsuario,
      status: status,
      isPrazoFatal: prazoFatal,
      fase: fase,
      partes: this.state.partesMiniAgenda,
      classificacao: classificacao,
      ordenacao: ordenacao
    }

    this.setState({openSpinner: true});
    await this.atividadeService.listarAtividadesPorDataLimite(filtro)
      .then(response => {
        this.setState({atividadesLista: response.data});
        this.setState({dataFiltroAgendaConsulta: ''});
        this.setState({exibirAtividades: 'block'});
        this.fecharModalAtividade('modalFiltroAtividades');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
        this.setState({openSpinner: false});
      });
      this.setState({openSpinner: false});
  }

  editarMesMiniAgenda = () => {
    this.abrirModal('modalAlterarMiniAgenda');
  }

  alterarPeriodoMiniAgenda = async () => {
    if(this.state.mesMiniAgenda == null) {
      this.toast.show({severity:'error', summary: 'Alterar Agenda', detail:'Informe o mês', life: 4000});
      return;
    }

    if(this.state.anoMiniAgenda == null) {
      this.toast.show({severity:'error', summary: 'Alterar Agenda', detail:'Informe o ano', life: 4000});
      return;
    }

    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.atividadeService.consultarAgendaMesUsuario(usuarioLogado.codigo,this.state.mesMiniAgenda.mes,
      this.state.anoMiniAgenda.ano)
      .then(response => {
        this.setState({agenda: response.data});
        var nomeMes = this.obterNomeDoMes(this.state.mesMiniAgenda.mes);
        this.setState({descricaoMes: nomeMes + "/" + this.state.anoMiniAgenda.ano});
        this.fecharModalCadastro('modalAlterarMiniAgenda');
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async abrirModal(name, position){
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    //this.diasCalendario(5,2024);
    this.setState({pesquisaAtividade: ''});
    await this.listarStatusAtividade();
    await this.atividadesAtrasadasResponsavel();
    await this.atividadesHojeResponsavel();
    await this.atividadesSeteResponsavel();
    await this.atividadesTrintaResponsavel();
    this.atividadesAtrasadasInteressados();
    this.atividadesHojeInteressados();
    this.atividadesSeteInteressados();
    this.atividadesTrintaInteressados();
    //this.compromissosAtrasados();
    //this.compromissosHoje();
    //this.compromissosSete();
    //this.compromissosTrinta();
    this.graficoAtividadeUsuario();
    this.consultaAtividadesCriadasUsuario();
    this.consultaAtividadesUltimosTrintaDiasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasAtrasadasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasNoPrazoUsuario();
    //this.consultaPontuacao();


    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    const optionsChart = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
          legend: {
              labels: {
                  color: textColor
              }
          }
      },
      scales: {
          x: {
              ticks: {
                  color: textColorSecondary
              },
              grid: {
                  color: surfaceBorder
              }
          },
          y: {
              ticks: {
                  color: textColorSecondary
              },
              grid: {
                  color: surfaceBorder
              }
          }
      }
    };

    this.setState({optionsChart: optionsChart});

    //this.consultarAgendaMesUsuario();

    await this.gerarPontuacaoUsuario();

    await this.usuariosKanban();
    await this.gruposKanban();
    this.consultarKanban();

    await this.listarAgenda();

    this.setState({quantidadeTotalResponsavel: parseInt(this.state.quantidadeAtividadesAtrasadas) + 
              parseInt(this.state.quantidadeAtividadesHoje) + parseInt(this.state.quantidadeAtividadesSete) + 
              parseInt(this.state.quantidadeAtividadesTrinta)});
    
    this.setState({quantidadeTotalInteressados: parseInt(this.state.quantidadeAtrasadosInteressados) + 
              parseInt(this.state.quantidadeHojeInteressados) + parseInt(this.state.quantidadeSeteInteressados) + 
              parseInt(this.state.quantidadeTrintaInteressados)});

    this.setState({quantidadeTotalCompromissos: parseInt(this.state.quantidadeAtrasadosCompromissos) + 
                  parseInt(this.state.quantidadeHojeCompromissos) + parseInt(this.state.quantidadeSeteCompromissos) + 
                parseInt(this.state.quantidadeTrintaCompromissos)});

    this.setState({openSpinner: false});
    
  }

  obterNomeDoMes(numeroDoMes) {
    const meses = [
        "Janeiro", "Fevereiro", "Março",
        "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro",
        "Outubro", "Novembro", "Dezembro"
    ];

    if (numeroDoMes >= 1 && numeroDoMes <= 12) {
        return meses[numeroDoMes - 1];
    } else {
        return "Número de mês inválido. Deve estar entre 1 e 12.";
    }
  }

  consultarAgendaMesUsuario = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const dataAtual = new Date();
    const mesAtual = dataAtual.getMonth() + 1; // Adicionamos 1 porque os meses vão de 0 a 11
    const anoAtual = dataAtual.getFullYear();
    await this.atividadeService.consultarAgendaMesUsuario(usuarioLogado.codigo,mesAtual,anoAtual)
      .then(response => {
        this.setState({agenda: response.data});
        var mesAtual = dataAtual.getMonth() + 1; // Adicione 1, pois os meses vão de 0 a 11
        var anoAtual = dataAtual.getFullYear();
        var nomeMes = this.obterNomeDoMes(mesAtual);
        this.setState({mesMiniAgenda: {
            mes: mesAtual,
            nome: nomeMes
        }});
        this.setState({descricaoMes: nomeMes + "/" + anoAtual});
        this.setState({anoMiniAgenda: {
          ano: anoAtual,
          nome: anoAtual
        }});

      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async onImportante(e) {
    console.log('Você está sendo chamado ? ');
    let selectedGrau = [...this.state.grauFiltro];

    if (e.checked)
      selectedGrau.push(e.value);
    else
      selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

    await this.setState({ grauFiltro: selectedGrau });
    await this.consultarPaineis();
  }

  async consultarPaineis() {
    this.setState({openSpinner: true});
    await this.atividadesAtrasadasResponsavel();
    await this.atividadesHojeResponsavel();
    await this.atividadesSeteResponsavel();
    await this.atividadesTrintaResponsavel();
    await this.atividadesAtrasadasInteressados();
    await this.atividadesHojeInteressados();
    await this.atividadesSeteInteressados();
    await this.atividadesTrintaInteressados();
    //await this.compromissosAtrasados();
    //await this.compromissosHoje();
    //await this.compromissosSete();
    //await this.compromissosTrinta();
    await this.consultaAtividadesCriadasUsuario();
    await this.consultaAtividadesUltimosTrintaDiasUsuario();
    await this.consultaAtividadesUltimosTrintaDiasConcluidasUsuario();
    await this.consultaAtividadesUltimosTrintaDiasConcluidasAtrasadasUsuario();
    await this.consultaAtividadesUltimosTrintaDiasConcluidasNoPrazoUsuario();
    await this.consultarKanban();
    //await this.listarAgenda();

    this.setState({quantidadeTotalResponsavel: parseInt(this.state.quantidadeAtividadesAtrasadas) + 
          parseInt(this.state.quantidadeAtividadesHoje) + parseInt(this.state.quantidadeAtividadesSete) + 
          parseInt(this.state.quantidadeAtividadesTrinta)});
    
    this.setState({quantidadeTotalInteressados: parseInt(this.state.quantidadeAtrasadosInteressados) + 
            parseInt(this.state.quantidadeHojeInteressados) + parseInt(this.state.quantidadeSeteInteressados) + 
            parseInt(this.state.quantidadeTrintaInteressados)});

    //this.setState({quantidadeTotalCompromissos: parseInt(this.state.quantidadeAtrasadosCompromissos) + 
      //          parseInt(this.state.quantidadeHojeCompromissos) + parseInt(this.state.quantidadeSeteCompromissos) + 
        //      parseInt(this.state.quantidadeTrintaCompromissos)});
 
    if(this.state.pesquisaAtividade == '' && this.state.grauFiltro.length == 0) {
      this.setState({exibeOcorrenciasEncontradas: 'none'});
    } else {
      this.setState({exibeOcorrenciasEncontradas: 'block'})
      this.setState({ocorrenciasEncontradas: parseInt(this.state.quantidadeAtividadesAtrasadas) + 
        parseInt(this.state.quantidadeAtividadesHoje) + parseInt(this.state.quantidadeAtividadesSete) + 
        parseInt(this.state.quantidadeAtividadesTrinta) +
        parseInt(this.state.quantidadeAtrasadosInteressados) + 
        parseInt(this.state.quantidadeHojeInteressados) + parseInt(this.state.quantidadeSeteInteressados) + 
        parseInt(this.state.quantidadeTrintaInteressados) +  ' Ocorrência(s) filtrada(s)'});
    }

    this.setState({openSpinner: false});
    //this.refreshPage();
  }

  async consultarPaineisAlteracao() {
    this.setState({openSpinner: true});
    this.setState({tabAtivo: 1});
    this.atividadesAtrasadasResponsavel();
    this.atividadesHojeResponsavel();
    this.atividadesSeteResponsavel();
    this.atividadesTrintaResponsavel();
    this.atividadesAtrasadasInteressados();
    this.atividadesHojeInteressados();
    this.atividadesSeteInteressados();
    this.atividadesTrintaInteressados();
    //this.compromissosAtrasados();
    //this.compromissosHoje();
    //this.compromissosSete();
    //this.compromissosTrinta();
    this.graficoAtividadeUsuario();
    this.consultaAtividadesCriadasUsuario();
    this.consultaAtividadesUltimosTrintaDiasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasAtrasadasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasNoPrazoUsuario();
    this.consultarKanban();

    this.setState({quantidadeTotalResponsavel: parseInt(this.state.quantidadeAtividadesAtrasadas) + 
          parseInt(this.state.quantidadeAtividadesHoje) + parseInt(this.state.quantidadeAtividadesSete) + 
          parseInt(this.state.quantidadeAtividadesTrinta)});
    
    this.setState({quantidadeTotalInteressados: parseInt(this.state.quantidadeAtrasadosInteressados) + 
            parseInt(this.state.quantidadeHojeInteressados) + parseInt(this.state.quantidadeSeteInteressados) + 
            parseInt(this.state.quantidadeTrintaInteressados)});

    //this.setState({quantidadeTotalCompromissos: parseInt(this.state.quantidadeAtrasadosCompromissos) + 
      //          parseInt(this.state.quantidadeHojeCompromissos) + parseInt(this.state.quantidadeSeteCompromissos) + 
        //      parseInt(this.state.quantidadeTrintaCompromissos)});
    
    await this.gerarPontuacaoUsuario();

    this.setState({openSpinner: false});
    //this.refreshPage();
  }

  atualizarPaineis = () => {
    this.atividadesAtrasadasResponsavel();
    this.atividadesHojeResponsavel();
  }

  consultarTituloAtividadeNome = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.consultarPorNome(this.state.titulo, usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tituloAtividadeCodigo: response.data.codigo});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarAtividadeCustom(atividade) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.consultarAtividadeCustom(atividade.codigoAtividade,usuarioLogado.empresa.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({codigoProcesso: response.data.codigoProcesso});
        this.setState({titulo: response.data.titulo});
        this.setState({pontuacao: response.data.pontos + " pontos"});
        this.setState({usuarioCriouAtividade: response.data.usuarioCriou});
        this.setState({dataRegistroAtividade: response.data.dataCriacao});
        this.setState({descricao: response.data.descricao});
        this.setState({grupoTrabalhoDescricao: response.data.grupo});
        this.setState({subGrupoTrabalhoDescricao: response.data.subGrupo});
        this.setState({codigoSubGrupo: response.data.codigoSubGrupo});
        this.setState({codigoGrupo: response.data.codigoGrupo});
        if(response.data.pessoa != null) {
          this.setState({pessoa: response.data.pessoa});
          this.setState({campoPessoaPesquisada: 'block'});
          this.setState({pessoaPesquisada: response.data.pessoa.nome});
        } else {
          this.setState({campoPessoaPesquisada: 'none'});
          this.setState({pessoaPesquisada: ''});
        }
        this.setState({tipo: response.data.tipo});
        this.setState({fase: response.data.fase});
        if(response.data.processo != null) {
          this.setState({processoPesquisadoVisivel: 'block'});
          this.setState({codigoProcesso: response.data.codigoProcesso});
          this.setState({partes: response.data.partes});
          if(response.data.fase != null) {
            this.setState({processoPesquisado: response.data.processo + " - " + response.data.fase});
          } else {
            this.setState({processoPesquisado: response.data.processo});
          }
        } else {
            this.setState({processoPesquisadoVisivel: 'none'});
        }

        if(response.data.tipo == 'A') {
          this.setState({horaAntiga: response.data.hora})
          this.setState({hora: response.data.hora});
        }

        this.setState({dataLimiteAntiga: response.data.dataLimite});
        var dataLimite = new Date(response.data.dataLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        if(response.data.prazoFatal != null) {
          var dataFatal = new Date(response.data.prazoFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }

        this.setState({statusCodigo: response.data.statusCodigo});
        this.setState({status: response.data.statusEntty})
        this.setState({statusAtividade: response.data.status});

        let grau = [];
        if(response.data.importante == 'S') {
          grau.push('importante');
        }

        if(response.data.urgente == 'S') {
          grau.push('urgente');
        }

        if(response.data.privado == 'S') {
          grau.push('privado');
        }
        this.setState({grau: grau});
        //Responsáveis
        this.setState({responsaveisLista: response.data.responsaveisAtividade});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.setState({responsaveis: response.data.usuariosGrupo});
        //Interessados
        this.setState({interessadosLista: response.data.interessadosAtividade});
        if(response.data.interessadosAtividade != null) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.setState({interessados: response.data.usuariosGrupo});
        if(response.data.lancamentoFinanceiro != null) {
          this.setState({isLancamento: true});
          this.setState({linkLancamento: 'hide'});
        }
      }).catch(error => {
        console.log('Error ', error);
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      if(atividade.descricaoStatus == 'Criada') {
        this.atividadesAtrasadasResponsavel();
        this.atividadesHojeResponsavel();
        this.atividadesSeteResponsavel();
        this.atividadesTrintaResponsavel();
        this.atividadesAtrasadasInteressados();
        this.atividadesHojeInteressados();
        this.atividadesSeteInteressados();
        this.atividadesTrintaInteressados();
      }
      //Abre modal
      this.abrirModalAtividadeAlterar('displayAtividade');
      this.setState({openSpinner: false});
  }
  
  async consultarAtividadeCustomCalendario(atividade) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.consultarAtividadeCustom(atividade.codigo,usuarioLogado.empresa.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({codigoProcesso: response.data.codigoProcesso});
        this.setState({titulo: response.data.titulo});
        this.setState({pontuacao: response.data.pontos + " pontos"});
        this.setState({usuarioCriouAtividade: response.data.usuarioCriou});
        this.setState({dataRegistroAtividade: response.data.dataCriacao});
        this.setState({descricao: response.data.descricao});
        this.setState({grupoTrabalhoDescricao: response.data.grupo});
        this.setState({subGrupoTrabalhoDescricao: response.data.subGrupo});
        this.setState({codigoSubGrupo: response.data.codigoSubGrupo});
        this.setState({codigoGrupo: response.data.codigoGrupo});
        this.setState({tipo: response.data.tipo});
        this.setState({fase: response.data.fase});
        if(response.data.processo != null) {
          this.setState({processoPesquisadoVisivel: 'block'});
          this.setState({codigoProcesso: response.data.codigoProcesso});
          this.setState({partes: response.data.partes});
          if(response.data.fase != null) {
            this.setState({processoPesquisado: response.data.processo + " - " + response.data.fase});
          } else {
            this.setState({processoPesquisado: response.data.processo});
          }
        } else {
            this.setState({processoPesquisadoVisivel: 'none'});
        }

        if(response.data.tipo == 'A') {
          this.setState({horaAntiga: response.data.hora})
          this.setState({hora: response.data.hora});
        }

        this.setState({dataLimiteAntiga: response.data.dataLimite});
        var dataLimite = new Date(response.data.dataLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        if(response.data.prazoFatal != null) {
          var dataFatal = new Date(response.data.prazoFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }

        this.setState({statusCodigo: response.data.statusCodigo});
        this.setState({status: response.data.statusEntty})
        this.setState({statusAtividade: response.data.status});

        let grau = [];
        if(response.data.importante == 'S') {
          grau.push('importante');
        }

        if(response.data.urgente == 'S') {
          grau.push('urgente');
        }

        if(response.data.privado == 'S') {
          grau.push('privado');
        }
        this.setState({grau: grau});
        //Responsáveis
        this.setState({responsaveisLista: response.data.responsaveisAtividade});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.setState({responsaveis: response.data.usuariosGrupo});
        //Interessados
        this.setState({interessadosLista: response.data.interessadosAtividade});
        if(response.data.interessadosAtividade != null) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }

        this.setState({interessados: response.data.usuariosGrupo});

        this.setState({descricaoStatus: response.data.statusEntty.status});

      }).catch(error => {
        console.log('Error ', error);
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })

      if(atividade.descricaoStatus == 'Criada') {
        this.atividadesAtrasadasResponsavel();
        this.atividadesHojeResponsavel();
        this.atividadesSeteResponsavel();
        this.atividadesTrintaResponsavel();
        this.atividadesAtrasadasInteressados();
        this.atividadesHojeInteressados();
        this.atividadesSeteInteressados();
        this.atividadesTrintaInteressados();
      }

      //Abre modal
      this.abrirModalAtividadeAlterar('displayAtividade');
      this.setState({openSpinner: false});
  }

  async consultarAtividade(atividade) {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.atividadeService.consultarAtividade(atividade.codigoAtividade,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({pontuacao: response.data.pontuacao + " pontos"});
        this.setState({usuarioCriouAtividade: response.data.usuario.nome});
        this.setState({dataRegistroAtividade: response.data.dtRegistro});
        this.setState({descricao: response.data.descricao});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({tipo: response.data.tipo});
        this.consultarGruposTrabalho();
        this.setState({selectSubGrupo: response.data.subGrupo});
        this.setState({fase: response.data.fase});
        if(response.data.processo != null) {
          this.setState({partes: atividade.partes});
          
          if(atividade.favorito != null && atividade.favorito != 'N') {
            this.setState({favorito: 'p-button-rounded p-button-danger'});
            this.setState({titleFavorito: 'Processo classificado como meus favoritos'});
            this.setState({exibirFavorito: 'hide'});
          } else {
            this.setState({favorito: 'p-button-rounded p-button-secondary'});
            this.setState({titleFavorito: 'Este processo não está classificado como meus favoritos'});
            this.setState({exibirFavorito: 'none'});
          }
          if(atividade.importante != null && atividade.importante != 'N') {
            this.setState({importante: 'p-button-rounded p-button-warning'});
            this.setState({titileImportante: 'Processo importante para empresa'});
            this.setState({exibirImportanteEmpresa: 'hide'});
          } else {
            this.setState({importante: 'p-button-rounded p-button-secondary'});
            this.setState({titileImportante: 'Processo normal'});
            this.setState({exibirImportanteEmpresa: 'none'});
          }
          this.setState({processo: response.data.processo});
          if(response.data.processo.nrCnj != '') {
            if(response.data.processo.fase != null) {
              this.setState({processoPesquisado: response.data.processo.nrCnj + " - " + response.data.processo.fase.nome});
            } else {
              this.setState({processoPesquisado: response.data.processo.nrCnj});
            }
          } else {
            if(response.data.processo.fase != null) {
              this.setState({processoPesquisado: response.data.processo.nrProcesso + " - " + response.data.processo.fase.nome});
            } else {
              this.setState({processoPesquisado: response.data.processo.nrProcesso});
            }
          }
          this.setState({processoPesquisadoVisivel: 'block'});
          this.setState({sizePesquisa: 'col-sm-5'});
          this.setState({campoPesquisaProcesso: 'none'});
          if(response.data.processo.nrCnj != null && response.data.processo.nrCnj != '') {
            if(response.data.processo.fase != null) {
              this.setState({processoPesquisado: response.data.processo.nrCnj + " - " + response.data.processo.fase.nome});
            } else {
              this.setState({processoPesquisado: response.data.processo.nrCnj});
            }
          } else {
            if(response.data.processo.fase != null) {
              this.setState({processoPesquisado: response.data.processo.nrProcesso + " - " + response.data.processo.fase.nome});
            } else {
              this.setState({processoPesquisado: response.data.processo.nrProcesso});
            }
          }
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'block'
          }});
          this.setState({bloqueiaGrupo: true});
        } else {
          this.setState({processo: null});
          this.setState({sizePesquisa: 'col-sm-12'});
          this.setState({bloqueiaGrupo: false});
          this.setState({processoPesquisado: ''});
          this.setState({processoPesquisadoVisivel: 'none'});
          this.setState({campoPesquisaProcesso: 'block'})
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'none'
          }});
          this.setState({pesquisaProcesso: ''});
        }
        var dataLimite = new Date(response.data.dtLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
      
        this.setState({status: response.data.status})
        let grau = [];
        if(response.data.importante == 'S') {
          grau.push('importante');
        }

        if(response.data.urgente == 'S') {
          grau.push('urgente');
        }

        if(response.data.privado == 'S') {
          grau.push('privado');
        }

        if(response.data.pessoa != null) {
          this.setState({pessoa: response.data.pessoa});
          this.setState({campoPessoaPesquisada: 'block'});
          this.setState({pessoaPesquisada: response.data.pessoa.nome});
        } else {
          this.setState({campoPessoaPesquisada: 'none'});
          this.setState({pessoaPesquisada: ''});
        }

        this.setState({grau: grau});
        this.listarExecucaoCheckList(response.data.codigo);
      }
    ).catch(error => {
        console.log('Error ', error);
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    });

    if(atividade.descricaoStatus == 'Criada') {
      this.atividadesAtrasadasResponsavel();
      this.atividadesHojeResponsavel();
      this.atividadesSeteResponsavel();
      this.atividadesTrintaResponsavel();
      this.atividadesAtrasadasInteressados();
      this.atividadesHojeInteressados();
      this.atividadesSeteInteressados();
      this.atividadesTrintaInteressados();
    }
    await this.listarArquivosAtividade();
    await this.consultarResponsaveis();
    await this.listarStatusAtividadeConsulta();
    await this.consultarInteressados();   
    await this.consultarGruposTrabalho(); 
    this.abrirModalAtividadeAlterar('displayAtividade');
    this.setState({openSpinner: false});
  }

  async consultarAtividadeCalendario(atividade) {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.atividadeService.consultarAtividade(atividade.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({usuarioCriouAtividade: response.data.usuario.nome});
        this.setState({dataRegistroAtividade: response.data.dtRegistro});
        this.setState({descricao: response.data.descricao});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({tipo: response.data.tipo});
        this.consultarGruposTrabalho();
        this.setState({selectSubGrupo: response.data.subGrupo});
        this.setState({fase: response.data.fase});
        if(response.data.processo != null) {
          this.setState({partes: atividade.partes});
          if(atividade.favorito != null && atividade.favorito != 'N') {
            this.setState({favorito: 'p-button-rounded p-button-danger'});
            this.setState({titleFavorito: 'Processo classificado como meus favoritos'});
            this.setState({exibirFavorito: 'hide'});
          } else {
            this.setState({favorito: 'p-button-rounded p-button-secondary'});
            this.setState({titleFavorito: 'Este processo não está classificado como meus favoritos'});
            this.setState({exibirFavorito: 'none'});
          }
          if(atividade.importante != null && atividade.importante != 'N') {
            this.setState({importante: 'p-button-rounded p-button-warning'});
            this.setState({titileImportante: 'Processo importante para empresa'});
            this.setState({exibirImportanteEmpresa: 'hide'});
          } else {
            this.setState({importante: 'p-button-rounded p-button-secondary'});
            this.setState({titileImportante: 'Processo normal'});
            this.setState({exibirImportanteEmpresa: 'none'});
          }
          this.setState({processo: response.data.processo});
          this.setState({processoPesquisado: response.data.processo.nrCnj});
          this.setState({processoPesquisadoVisivel: 'block'});
          this.setState({sizePesquisa: 'col-sm-5'});
          this.setState({campoPesquisaProcesso: 'none'});
          if(response.data.processo.nrCnj != null && response.data.processo.nrCnj != '') {
            var cnjMascarado = response.data.processo.nrCnj.substring(0, 7);
                cnjMascarado = cnjMascarado + "-" + response.data.processo.nrCnj.substring(7, 9);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(9, 13);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(13, 14);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(14, 16);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(16, 20);
            this.setState({processoPesquisado: cnjMascarado});
          } else {
            this.setState({processoPesquisado: response.data.processo.nrProcesso});
          }
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'block'
          }});
          this.setState({bloqueiaGrupo: true});
        } else {
          this.setState({processo: null});
          this.setState({sizePesquisa: 'col-sm-12'});
          this.setState({bloqueiaGrupo: false});
          this.setState({processoPesquisado: ''});
          this.setState({processoPesquisadoVisivel: 'none'});
          this.setState({campoPesquisaProcesso: 'block'})
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'none'
          }});
          this.setState({pesquisaProcesso: ''});
        }
        var dataLimite = new Date(response.data.dtLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
        
        this.setState({status: response.data.status})
      }
    ).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    });
    await this.listarArquivosAtividade();
    await this.consultarResponsaveis();
    await this.consultarInteressados();   
    await this.consultarGruposTrabalho(); 
    if(usuarioLogado.empresa.tituloPredefinido == 'N') {
      await this.listarFases();
    } else {
      await this.consultarTituloAtividadePorNome(this.state.titulo, usuarioLogado.empresa.codigo);
      await this.listarFasesPorTitulo(this.state.tituloAtividade);
    }
    this.abrirModalAtividadeAlterar('displayAtividade');
    this.setState({openSpinner: false});
  }

  listarArquivosAtividade = async () => {
    await this.arquivoAtividadeService.listarArquivos(this.state.atividade.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
        if(response.data.length > 0) {
          this.setState({exibirLinkAnexo: 'block'});
        } else {
          this.setState({exibirLinkAnexo: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async abrirModalArquivosAnexos(name, position){
    await this.listarArquivosAtividade()
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  async onGrupoTrabalhoChange(e) {
    await this.setState({selectGrupo: e.value});
    this.consultarSubGrupos(this.state.selectGrupo.codigo);
    await this.setState({responsaveisLista: null});
    await this.setState({interessadosLista: null});
    this.listarResponsaveis();
    this.listarInteressados();
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  onChangeStatusAtividade(e) {
    this.setState({status: e.value})
  }

  consultarProcessoPorIndice = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    const indice = {
      indice: this.state.pesquisaProcesso,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }

    await this.processoService.consultarProcessoPorIndice(indice)
      .then(response => {
        this.setState({processos: response.data});
        if(response.data.length > 0) {
          this.abrirModalProcesso('displayProcesso');
        } else {
          this.setState({pesquisaProcesso: ''});
          this.toast.show({severity:'error', summary: 'Processo', detail:'Processo não encontrado', life: 4000});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }

  excluirPesquisaProcesso = async () => {
    this.setState({processo: null});
    this.setState({pesquisaProcesso: ''});
    this.setState({processoPesquisado: ''});
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({campoPesquisaProcesso: 'block'});
    this.setState({bloqueiaGrupo: false});
    this.setState({selectGrupo: null});
    this.setState({subGrupos: null});
    this.setState({selectSubGrupo: null});
    this.setState({responsaveisLista: []});
    this.setState({interessadosLista: []});
    this.setState({responsaveis: ''});
  }

  abrirModalProcesso(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  acoesProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-check" className="p-button-rounded p-button-text" 
                tooltip="Editar"
                onClick={() => this.selecionarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  renderFooterProcesso(name) {
    return (
        <div className="left">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  async selecionarProcesso(processo) {
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.processoService.consultarProcessoPorCodigo(processo.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({processo: response.data});
        this.setState({pesquisaProcesso: processo.nrCnj});
        this.setState({selectGrupo: response.data.grupoTrabalho})
        this.setState({bloqueiaGrupo: true});
        this.setState({campoPesquisaProcesso: 'none'});
        this.setState({processoPesquisadoVisivel: 'block'});
        this.setState({sizePesquisa: 'col-sm-5'});
        this.setState({escondeBotalExcluirPesquisa: {
          display: 'block'
        }});

        if(response.data.nrCnj != '') {
          var cnjMascarado = response.data.nrCnj.substring(0, 7);
              cnjMascarado = cnjMascarado + "-" + response.data.nrCnj.substring(7, 9);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(9, 13);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(13, 14);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(14, 16);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(16, 20);
          this.setState({processoPesquisado: cnjMascarado});
        } else {
          this.setState({processoPesquisado: response.data.nrProcesso});
        }
        
        this.setState({exibirFavorito: 'none'});
        this.setState({exibirImportanteEmpresa: 'none'});
        this.setState({selectSubGrupo: null});
        this.consultarSubGrupos(this.state.selectGrupo.codigo);
        this.listarResponsaveis();
        this.listarInteressados();
        this.fecharModalAtividade('displayProcesso');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner: false});
      });
      this.setState({openSpinner: false});
      this.setState({classeDiv: 'hide'});
      this.setState({separador: 'none'});
  }

  alterarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.titulo == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.responsaveisLista == null || this.state.responsaveisLista.size == 0) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    let tipoTarefa = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.atividade.tipo == "L") {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
        tipoTarefa = 'L';
      } else {
        if(this.state.hora != '' && this.state.hora != null) {
          var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
          tipoTarefa = 'A';
        } else {
          var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
          tipoTarefa = 'T';
        }
      }
    }

    var dataFormatadaDataFatal = "";
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != null && this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';
    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    var processo = null;
    if(this.state.codigoProcesso != null) {
      processo = {
        codigo: this.state.codigoProcesso
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.titulo,
        tipo: tipoTarefa,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        processo: processo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.status,
        subGrupo: {
          codigo: this.state.codigoSubGrupo,
          grupoPai: this.state.codigoGrupo
        },
        importante: importante,
        urgente: urgente,
        privado: privado,
        pessoa: this.state.pessoa
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    var hora = "00:00";
    if(this.state.horaAntiga != null && this.state.horaAntiga != "") {
      hora = this.state.horaAntiga;
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarAtividade(this.state.dataLimiteAntiga + " " + hora + ":00",
      this.state.statusCodigo, usuarioLogado.codigo,atividadeAlterar
      ).then(response => {
        this.consultarPaineisAlteracao();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
        this.fecharModalAtividade('displayAtividade');
      }).catch(error => {
        console.log('Error ', error);
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 8000});
      });
      this.setState({openSpinner: false});
  }

  refreshPage = () => {
    window.location.reload();
  }

  consultarResponsaveis = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'R')
      .then(response => {
        this.setState({responsaveisLista: response.data});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.listarResponsaveis(); 
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarInteressados = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'I')
      .then(response => {
        this.setState({interessadosLista: response.data});
        if(this.state.interessadosLista.length == 0) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.listarInteressados();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarHistorico = async () => {
    this.setState({openSpinner: true});
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
        this.abrirModalHistorico('displayHistorico');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesHistoricoUsuario(rowData) {
      if(rowData.tpHistorico == 'A') {
        return (
          <React.Fragment>
            <i className="fa fa-solid fa-robot" title="Incluído de forma automática"/>
          </React.Fragment>
        )
      } else {
        return (
          <React.Fragment>
            <i className="pi pi-user-plus" title="Incluído manualmente"/>
          </React.Fragment>
        )
      }
  }

  acoesHistorico(rowData) {
    if(rowData.tpHistorico != 'A') {
      return (
        <React.Fragment>
           <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                   tooltip="Excluir Histórico"
                   onClick={() => this.confirmaExclusaoHistorico(rowData)}
                   tooltipOptions={{position: 'top'}}
                   style={{width: '20px', height: '10px'}}/>
        </React.Fragment>
      )
    } 
  }

  consultarGrupoTrabalhoPai = async (codigo) => {
    await this.grupoTrabalhoService.consultarGrupo(codigo)
      .then(response => {
        this.setState({selectGrupo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Grupo de Trabalho', life: 4000});
      })
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Alterar" 
                    onClick={this.alterarAtividade}
                    className="p-button-primary p-button-text"/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexados')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Histórico" 
                    icon="pi pi-history"
                    className="p-button-help p-button-text"
                    onClick={this.consultarHistorico}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalAtividadeAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModalDescricao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModalHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  novoHistorico = () => {
    this.setState({dsHistorico: ''});
    this.abrirModalHistorico('displayHistoricoIncluir');
  }

  async incluirHistorico () {
    const usuarioLogado = this.context.usuarioAutenticado
    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    let tipoHistorico = 'M';
    if(usuarioLogado.empresa.codigo == 138) {
      let data = 'N';
        if(this.state.mudancaDataHistorico != null & this.state.mudancaDataHistorico.length > 0) {
          for(let i = 0; i < this.state.mudancaDataHistorico.length; i++) {
            if(this.state.mudancaDataHistorico[i] == 'mudancaData') {
              data = 'S'
            }
          }
        }

        if(data == 'S') {
          tipoHistorico = 'D';
        } else {
          tipoHistorico = 'M';
        }
    } else {
      tipoHistorico = 'M';
    }

    this.setState({openSpinner: true});
    await this.atividadeService.incluirHistorico({
      atividade: {
        codigo: this.state.codigo
      },
      dsHistorico: this.state.dsHistorico,
      usuario: usuarioLogado,
      tpHistorico: tipoHistorico
    }).then(response => {
      this.listarHistorico();
      this.fecharModalAtividade('displayHistoricoIncluir');
      this.toast.show({severity:'success', summary: 'Histórico de Atividade', detail:'Histórico incluído com sucesso', life: 4000});
    }).catch(error => {
      this.setState({openSpinner: false});
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Histórico de Atividade', detail:`${this.state.detail}`, life: 4000});
    })
    this.setState({openSpinner: false});
  }

  listarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  confirmaExclusaoHistorico(historico) {
    this.setState({registroHistorico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir o Histórico da Atividade?',
        header: 'Exclusão de Histórico de Atividades',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistorico,
        reject: this.reject
    });
  }

  acceptExcluirHistorico() {
    this.excluirHistorico();
  }

  excluirHistorico = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.excluirHistorico(this.state.registroHistorico.codigo, this.state.registroHistorico.usuario.codigo, usuarioLogado.codigo)
      .then(response => {
        this.listarHistorico();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico excluído', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  consultarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      })
  }

  consultarSubGrupos = async(codigo) => {
    await this.grupoTrabalhoService.listarSubGrupos(codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  Processo(data,status) {
    return (
        <div className="card">
          <div className="col-12">
            <div>
                <div>
                    <div style={{paddingTop: '5px', paddingBottom: '5px'}} className={status}>{data.statusCalculado}</div>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividadeCustom(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtFatal}</strong>
                    </div>
                    <div className="product-name"><a className="cursor" onClick={() => this.editarProcesso(data)}>{data.processo.nrCnj}</a></div>
                    <div className="grupoTrabalho">{data.processo.grupoTrabalho.nome}</div>
                    <div style={{paddingBottom: '5px', paddingTop: '5px'}}>{data.processo.autor}</div>
              </div>
            </div>
          </div>
        </div>
    );
  }

  editarProcesso(atividade) {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${atividade.codigoProcesso}/SEARCH`});
  }

  editarProcessoConsultaAgenda(atividade) {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${atividade.codigoProcesso}/SEARCH`});
  }

  editarProcessoNaAtividade = () => {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${this.state.codigoProcesso}/SEARCH`});
    //this.props.history.push(`/fichaProcesso/${atividade.codigoProcesso}`);
  }

  templateSemProcesso(data, status) {

    var financeiro = 'none';
    var importanteAtividade = 'none';
    var urgente = 'none';

    if(data.snFinanceiro == 'FINANCEIRO') {
      financeiro = 'block';
    } else {
      financeiro = 'none';
    }

    if(data.importanteAtividade == 'S') {
      importanteAtividade = 'block';
    } else {
      importanteAtividade = 'none';
    }
  
    if(data.urgencia == 'S') {
      urgente = 'block';
    } else {
      urgente = 'none';
    }
    
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <br/>
                    <div style={{ display: 'flex'}}>
                      <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.descricaoStatus}></Tag>
                      &nbsp;&nbsp;
                      <Tag style={{background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', display: `${financeiro}`}}>
                        <div className="flex align-items-center gap-2">
                            <i className="pi pi-dollar"></i>
                            <span className="text-base">Financeiro</span>
                        </div>
                      </Tag>
                      &nbsp;
                      <Tag className="p-mr-2" style={{backgroundColor: '#4801FF', display: `${importanteAtividade}`}} value="Importante"></Tag>
                      &nbsp;
                      <Tag className="p-mr-2" style={{backgroundColor: 'red', display: `${urgente}`}} value="Urgente"></Tag>
                    </div>
                    <br></br>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividadeCustom(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtfatal}</strong>
                    </div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }

  templateCliente(data, status) {
    var financeiro = 'none';
    var importanteAtividade = 'none';
    var urgente = 'none';

    if(data.snFinanceiro == 'FINANCEIRO') {
      financeiro = 'block';
    } else {
      financeiro = 'none';
    }

    if(data.importanteAtividade == 'S') {
      importanteAtividade = 'block';
    } else {
      importanteAtividade = 'none';
    }
  
    if(data.urgencia == 'S') {
      urgente = 'block';
    } else {
      urgente = 'none';
    }

    return (
      <div className="card" style={{borderRadius: '6px'}}>
        <div className="col-12">
          <div>
              <div>
                  <br/>
                  <div style={{ display: 'flex'}}>
                    <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.descricaoStatus}></Tag>
                    &nbsp;&nbsp;
                    <Tag style={{background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', display: `${financeiro}`}}>
                      <div className="flex align-items-center gap-2">
                          <i className="pi pi-dollar"></i>
                          <span className="text-base">Financeiro</span>
                      </div>
                    </Tag>
                    &nbsp;
                    <Tag className="p-mr-2" style={{backgroundColor: '#4801FF', display: `${importanteAtividade}`}} value="Importante"></Tag>
                    &nbsp;
                    <Tag className="p-mr-2" style={{backgroundColor: 'red', display: `${urgente}`}} value="Urgente"></Tag>
                  </div>
                  <br></br>
                  <div className="titulo">
                      <a onClick={() => this.consultarAtividadeCustom(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                      <strong className="dataFatal">{data.dtfatal}</strong>
                  </div>
                  <div className="titulo">
                        {data.nomeCliente}&nbsp;&nbsp;
                    </div>
                  <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                  <br/>
              </div>
          </div>
        </div>
      </div>
    );
  }

  templateSemProcessoKanban(data) {
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <br/>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividade(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtfatal}</strong>
                    </div>
                    <div className="grupoTrabalho">{data.fase}</div>
                    <div className="usuario">
                      {data.responsaveis}
                    </div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }

  templateProcesso(data,status) {
    var favorito = '';
    var titleFavorito = '';
    var exibirFavorito = '';
    var importante = '';
    var titileImportante = '';
    var exibirImportanteEmpresa = '';
    var processo = '';
    var financeiro = 'none';
    var importanteAtividade = 'none';
    var urgente = 'none';
    if(data.favorito != null && data.favorito != 'N') {
      favorito = 'p-button-rounded p-button-danger';
      titleFavorito = 'Este processo está classificado como meus favoritos';
      exibirFavorito = 'hide';
    } else {
      favorito = 'p-button-rounded p-button-secondary';
      titleFavorito = 'Este processo não está classificado como meus favoritos';
      exibirFavorito = 'none';
    }

    if(data.importante != null && data.importante != 'N') {
      importante = 'p-button-rounded p-button-warning';
      titileImportante = 'Processo classificado como importante para empresa';
      exibirImportanteEmpresa = 'hide';
    } else {
      importante = 'p-button-rounded p-button-secondary';
      titileImportante = 'Processo normal';
      exibirImportanteEmpresa = 'none';
    }

    if(data.cnj != '') {
      processo = data.cnj;
    } else {
      processo = data.nrprocesso;
    }

    if(data.snFinanceiro == 'FINANCEIRO') {
      financeiro = 'block';
    } else {
      financeiro = 'none';
    }

    if(data.importanteAtividade == 'S') {
      importanteAtividade = 'block';
    } else {
      importanteAtividade = 'none';
    }
  
    if(data.urgencia == 'S') {
      urgente = 'block';
    } else {
      urgente = 'none';
    }

    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <br/>
                    <div style={{ display: 'flex'}}>
                      <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.descricaoStatus}></Tag>
                      &nbsp;&nbsp;
                      <Tag style={{background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', display: `${financeiro}`}}>
                        <div className="flex align-items-center gap-2">
                            <i className="pi pi-dollar"></i>
                            <span className="text-base">Financeiro</span>
                        </div>
                      </Tag>
                      &nbsp;
                      <Tag className="p-mr-2" style={{backgroundColor: '#4801FF', display: `${importanteAtividade}`}} value="Importante"></Tag>
                      &nbsp;
                      <Tag className="p-mr-2" style={{backgroundColor: 'red', display: `${urgente}`}} value="Urgente"></Tag>
                    </div>
                    <br/>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividadeCustom(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtfatal}</strong>
                    </div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    
                    <div className="product-name" style={{textAlign: 'left'}}><a className="cursor" 
                                                    href={this.state.paramProcessoPrincipal}
                                                    target="_blank"
                                                    onClick={() => this.editarProcesso(data)}>{processo}</a></div>
                  
                    <div style={{paddingBottom: '5px', paddingTop: '5px'}}>{data.partes}</div>
                    <div style={{textAlign: 'left'}}>
                      <Button icon="pi pi-star"
                              className={favorito} 
                              tooltip={titleFavorito} 
                              tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                              style={{width: '20px', height: '10px', display: `${exibirFavorito}`}}/>
                      &nbsp;
                      <Button icon="pi pi-heart" 
                              className={importante}
                              tooltip={titileImportante} 
                              tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                              style={{width: '20px', height: '10px', display: `${exibirImportanteEmpresa}`}} />
                    </div>
                </div>
            </div>
          </div>
        </div>
    );
  }

  templateProcessoKanban(data) {
    var favorito = '';
    var titleFavorito = '';
    var exibirFavorito = '';
    var importante = '';
    var titileImportante = '';
    var exibirImportanteEmpresa = '';
    if(data.favorito != null && data.favorito != 'N') {
      favorito = 'p-button-rounded p-button-danger';
      titleFavorito = 'Este processo está classificado como meus favoritos';
      exibirFavorito = 'hide';
    } else {
      favorito = 'p-button-rounded p-button-secondary';
      titleFavorito = 'Este processo não está classificado como meus favoritos';
      exibirFavorito = 'none';
    }

    if(data.importante != null && data.importante != 'N') {
      importante = 'p-button-rounded p-button-warning';
      titileImportante = 'Processo classificado como importante para empresa';
      exibirImportanteEmpresa = 'hide';
    } else {
      importante = 'p-button-rounded p-button-secondary';
      titileImportante = 'Processo normal';
      exibirImportanteEmpresa = 'none';
    }

    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <br/>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividadeCustom(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtfatal}</strong>
                    </div>
                    <div className="grupoTrabalho">{data.fase}</div>
                    <div className="usuario">
                      {data.responsaveis}
                    </div>
                    <div className="product-name"><a className="cursor" 
                                                     href={this.state.paramProcessoPrincipal}
                                                     target="_blank"
                                                     onClick={() => this.editarProcesso(data)}>{data.cnj}</a></div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    <div style={{paddingBottom: '5px', paddingTop: '5px'}}>{data.partes}</div>
                    <div style={{textAlign: 'left'}}>
                      <Button icon="pi pi-star"
                              className={favorito} 
                              tooltip={titleFavorito} 
                              tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                              style={{width: '20px', height: '10px', display: `${exibirFavorito}`}}/>
                      &nbsp;
                      <Button icon="pi pi-heart" 
                              className={importante}
                              tooltip={titileImportante} 
                              tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                              style={{width: '20px', height: '10px', display: `${exibirImportanteEmpresa}`}} />
                    </div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }
  
  templateProcessoKanbanConcluido(data) {
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <div className="titulo">
                        <br/>
                        <a onClick={() => this.consultarAtividadeCustom(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtConcluido}
                    </div>
                    <div className="usuario">
                      {data.responsaveis}
                    </div>
                    <div className="product-name"><a className="cursor" onClick={() => this.editarProcesso(data)}>{data.cnj}</a></div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    <div style={{paddingBottom: '5px', paddingTop: '5px'}}>{data.partes}</div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }

  templateSemProcessoKanbanConcluido(data) {
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <div className="titulo">
                        <br/>
                        <a onClick={() => this.consultarAtividadeCustom(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtConcluido}
                    </div>
                    <div className="usuario">
                      {data.responsaveis}
                    </div>
                    <div className="grupoTrabalho">{data.subGrupo}&nbsp; - &nbsp;{data.grupo}</div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }

  template(data) {
    let status = '';
    switch(data.status) {
      case 1:
          status = 'statusAtivo';
          break;
      case 2:
          status = 'statusAguardando';
          break;
      case 3:
          status = 'statusCancelado'
          break;
      case 4:
          status = 'statusCiente';
          break;
      case 5:
          status = 'statusConcluído'
          break;
      default:
          status = 'statusFazendo'
          break;
    }
    if(data.codigoProcesso != 0) {
      return this.templateProcesso(data,status);
    } else if(data.codigoCliente != 0) {
        return this.templateCliente(data,status);
    } else {
       return this.templateSemProcesso(data,status);
    }
  }

  templateKanban(data) {
    let status = '';
    switch(data.status) {
      case 1:
          status = 'statusAtivo';
          break;
      case 2:
          status = 'statusAguardando';
          break;
      case 3:
          status = 'statusCancelado'
          break;
      case 4:
          status = 'statusCiente';
          break;
      case 5:
          status = 'statusConcluído'
          break;
      default:
          status = 'statusFazendo'
          break;
    }
    if(data.status != 5) {
      if(data.codigoProcesso != 0) {
        return this.templateProcessoKanban(data, status);
      } else {
        return this.templateSemProcessoKanban(data, status);
      }
    } else {
      if(data.codigoProcesso != 0) {
        return this.templateProcessoKanbanConcluido(data, status);
      } else {
        return this.templateSemProcessoKanbanConcluido(data, status);
      }
    }
  }

  templateHistoricoAtividade(data) {
    var icone = '';
    var titulo = '';
    if(data.tpHistorico == 'A') {
      icone = 'fa fa-solid fa-robot';
      titulo = 'Incluído de forma automática';
    } else {
      icone = 'pi pi-user-plus';
      titulo = 'Incluído manualmente';
    }
    return (
      <div className="col-12">
        <div>
          <strong style={{textAlign: 'left', color: 'blue'}}
                  className="grupoTrabalho">
             {data.usuario.nome} - {data.dtHistorico}
          </strong>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong style={{textAlign: 'right'}}>
            <i className={icone} title={titulo}/>
          </strong>
        </div>
        <br />
        <div className="balao" style={{borderRadius: '6px'}}>
          {data.dsHistorico}
        </div>
        <br/>
      </div>
    )
  }

  //Tudo referente a upload de documentos
  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoAtividadeService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  async consultarArquivoDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  async consultarArquivo(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivo = () => {
    this.arquivoAtividadeService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosAtividade();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>

            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/>
            &nbsp;
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.adicionarDescricao}/> 

      </div>
    );
  }

  adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      dsArquivo: this.state.dsArquivo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosAtividade();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('atividade',upLoadFile.file, this.state.atividade.codigo) //Envia código de atividade para salvar os arquivos
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de atividade para salvar os arquivos
    await this.arquivoAtividadeService.incluirArquivo(data)
      .then(response => {
        this.listarArquivosAtividade();
        this.handleDelete(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  consultaAtividadesCriadasUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.atividadeService.consultaAtividadesCriadasUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesCriadasUsuario: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaAtividadesUltimosTrintaDiasUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.atividadeService.consultaAtividadesUltimosTrintaDias(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesUltimosTrintaDias: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaAtividadesUltimosTrintaDiasConcluidasUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.atividadeService.consultaAtividadesUltimosTrintaDiasConcluidas(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesUltimosTrintaDiasConcluidas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaAtividadesUltimosTrintaDiasConcluidasAtrasadasUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.atividadeService.consultaAtividadesUltimosTrintaDiasConcluidasAtrasadas(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesUltimosTrintaDiasConcluidasAtrasadas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaAtividadesUltimosTrintaDiasConcluidasNoPrazoUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.atividadeService.consultaAtividadesUltimosTrintaDiasConcluidasNoPrazo(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesUltimosTrintaDiasConcluidasNoPrazo: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaPontuacao = () => {
    this.atividadeService.consultaPontuacao(this.state.quantidadeAtividadesHoje,this.state.quantidadeHojeInteressados,this.state.quantidadeHojeCompromissos)
        .then(response => {
          this.setState({pontuacao: response.data});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Esquema de pontuação', detail:`${this.state.detail}`, life: 4000});
        })
  }

  acoesAtividadeConsultaCalendario(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.consultarAtividadeCustomCalendario(rowData)} style={{cursor: 'pointer', color: 'blue'}}>{rowData.atividade}</a>
      </React.Fragment>
    );
  }
 
  acoesAtividadeConsultaCalendarioProcesso(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.editarProcessoConsultaAgenda(rowData)}
           href={this.state.paramProcessoPrincipal} 
           style={{cursor: 'pointer', color: 'blue'}}
           target="_blank">{rowData.processo}
        </a>
      </React.Fragment>
    );
  }

  prazoFatal(rowData) {
    return(
      <React.Fragment>
        <span style={{color: 'red', fontWeight: 'bold'}}>{rowData.prazoFatal}</span>
      </React.Fragment>
    );
  }

  templateMniniAgenda(data) {
    return(
      <div style={{margin: '5px'}}>
        <div className="row">
          <div className="col-sm-4">
            <div style={{width: '30px', height: '30px', borderRadius: '10%', border: '1px solid red', color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '27px'}}>
              <span>{data.dia}</span>
            </div>
          </div>
          <div className="col-sm-4">
            <span style={{fontWeight: 'bold'}}>{data.diaSemana}</span>
          </div>
          <div className="col-sm-4">
            <a onClick={() => this.exibirAtividadesPorDataAgenda(data.dia)} style={{cursor: 'pointer', color: 'blue'}}> <span>{data.quantidadeTarefas}</span></a>
          </div>
        </div>
        <hr></hr>
      </div>
    );
  }

  onGrauChange(e) {
    let selectedGrau = [...this.state.grau];

    if (e.checked)
      selectedGrau.push(e.value);
    else
      selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

    this.setState({ grau: selectedGrau });
  }

  listarExecucaoCheckList = async (atividade) => {
    this.itensCheckList = [];
    this.setState({activeIndex: -1})
    await this.execucaoCheckListService.consultarCheckList(atividade)
      .then(response => {
        this.setState({checkList: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Check Lista', detail:`${this.state.detail}`, life: 4000});
      });

      for(let i = 0; i < this.state.checkList.length; i++) {
        if(this.state.checkList[i].status == 'F') {
          this.setState({activeIndex: this.state.checkList[i].checkList.ordem -1});
          break;
        } 
      }

      let item = null;
      for(let i = 0; i < this.state.checkList.length; i++) {
        item = {
          codigo: this.state.checkList[i].codigo,
          checklist: this.state.checkList[i].checkList.codigo,
          status:  this.state.checkList[i].status,
          label: this.state.checkList[i].checkList.tarefa
        }
        this.itensCheckList.push(item);
        this.abrirModal('displayAtividade');
      }
  }

  consultarExecucao = async (codigo) => {
    await this.execucaoCheckListService.consultar(codigo)
      .then(response => {
        this.setState({execucaoCheckList: response.data});
        if(response.data.status != 'A') {
          this.setState({usuarioCheckList: response.data.usuario.nome});
          this.setState({dataExecucaoCheckList: response.data.dataExecucao});
          if(response.data.status == 'F') {
            this.setState({statusExecucao: 'Fazendo'});
          } else {
            this.setState({statusExecucao: 'Consluído'});
          }
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Execução Check List', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async marcarCheckList(e){
    await this.consultarExecucao(e.item.codigo);
    if(this.state.execucaoCheckList.status != 'A') {
      this.abrirModal('modalCheckList');
      return;
    }
  
    const usuarioLogado = this.context.usuarioAutenticado
    const exec = {
      codigo: e.item.codigo,
      atividade: this.state.atividade,
      checkList: {
        codigo: e.item.checklist
      },
      usuario: usuarioLogado,
      status: 'F'
    };

    this.setState({openSpinner: true});
    await this.execucaoCheckListService.selecionarCheckList(exec)
      .then(response => {
        this.setState({activeIndex: e.index});
        this.listarExecucaoCheckList(this.state.atividade.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Check Lista', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  dateTemplate = (date) => {
    if (date.day > 5 && date.day < 17) {
        return (
            <strong className="circulo">{date.day}</strong>
        );
    }

    return date.day;
  }

  templateCriacaoAtividade = () => {
    return(
      <div>Atividade criada por:&nbsp;&nbsp;<strong style={{color: '#ccc'}}>{this.state.usuarioCriouAtividade}&nbsp; em:&nbsp;{this.state.dataRegistroAtividade}</strong></div>
    );
  }

  grauTemplate(data) {
    if(data.importante == 'S' && data.urgente == 'S') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'red', width: '20px'}} value="U"></Tag>
          &nbsp;
          <Tag style={{backgroundColor: '#3B82F6', width: '20px'}} value="I"></Tag>
        </React.Fragment>
      );
    } else if(data.importante == 'S' && data.urgente == 'N') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: '#3B82F6', width: '20px'}} value="I"></Tag>
        </React.Fragment>
      );
    } else if(data.importante == 'N' && data.urgente == 'S') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'red', width: '20px'}} value="U"></Tag>
        </React.Fragment>
      );
    }
  }

  limparConsultaAtividades = async () => {
    this.setState({openSpinner: true});
    this.setState({dataLimiteInicialMiniAgenda: null});
    this.setState({dataLimiteFinalMiniAgenda: null});
    this.setState({prazoFatalInicialMiniAgenda: null});
    this.setState({prazoFatalFinalMiniAgenda: null});
    this.setState({dataConclusaoInicialMiniAgenda: null});
    this.setState({dataConclusaoFinalMiniAgenda: null});
    this.setState({processoMiniAgenda: ''});
    this.setState({statusMiniAgenda: null});
    this.setState({partesMiniAgenda: ''});
    this.setState({financeiroMiniAgenda: null});
    this.setState({tipoUsuarioMiniAgenda: null});
    this.setState({faseMiniAgenda: null});
    this.setState({prazoFatalMiniAgenda: null});
    this.setState({importanteMiniAgenda: null});
    this.setState({urgenteMiniAgenda: null});
    this.setState({classificacaoMiniAgenda: null});
    this.setState({ordenacaoMiniAgenda: null});
    this.setState({atividadesLista: []});
    this.setState({openSpinner: false});
  }

  render() {
    const { upLoadFiles } = this.state;
    const { horizontalOptions, basicOptions } = this.options;
    const usuarioLogado = this.context.usuarioAutenticado;
    var exibieDataHistorico = 'none';
    if(usuarioLogado.empresa.codigo == 138) {
      exibieDataHistorico = 'block'
    } else {
      exibieDataHistorico = 'none'
    }

    var bloqueiaTitulo = '';
    if(usuarioLogado.empresa.codigo == 138) {
      bloqueiaTitulo = 'false';
    }

    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        {/**Consultar a execução da atividade por meio do checklist */}
        <Dialog header="Checklist de Atividade"
                visible={this.state.modalCheckList} 
                onHide={() => this.fecharModalAtividade('modalCheckList')}>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>Status: <strong>{this.state.statusExecucao}</strong></label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>Usuario: <strong>{this.state.usuarioCheckList}</strong></label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>Data: <strong>{this.state.dataExecucaoCheckList}</strong></label>
                </div>
              </div>
            </div>
        </Dialog>
        {/**Alterar Atividade */}
        <Dialog header={this.templateCriacaoAtividade} autoComplete="nope"
                visible={this.state.displayAtividade} 
                footer={this.renderFooterAtividade('displayAtividade')} 
                onHide={() => this.fecharModalAtividade('displayAtividade')}>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <h5><strong style={{color: '#000'}}>{this.state.titulo} - {this.state.pontuacao}</strong></h5>
                  <a style={{cursor: 'pointer'}}><Tag style={{background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', display: `${this.state.linkLancamento}`}}>
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-dollar"></i>
                        <span className="text-base">Financeiro</span>
                    </div>
                  </Tag>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <Steps model={this.itensCheckList} 
                           onSelect={(e) => this.marcarCheckList(e)}
                           activeIndex={this.state.activeIndex} 
                           readOnly={false} />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group" style={{display: `${this.state.campoPessoaPesquisada}`}}>
                  <strong>Pessoa:&nbsp;&nbsp;{this.state.pessoaPesquisada}</strong>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group" style={{display: `${this.state.processoPesquisadoVisivel}`}}>
                  <strong>Processo:&nbsp;&nbsp;
                            <a className="cursor" 
                               href={this.state.paramProcessoPrincipal}
                               target="_blank"
                               onClick={this.editarProcessoNaAtividade}>{this.state.processoPesquisado}</a>
                  <br/>
                  {this.state.partes}
                  </strong>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <InputText id="grupoDescricao" 
                            type="text" 
                            disabled
                            style={{width: '100%', height: '32px'}} 
                            value={this.state.grupoTrabalhoDescricao}
                            onChange={e => this.setState({grupoTrabalhoDescricao: e.target.value})}
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <InputText id="subgrupoDescricao" 
                             type="text" 
                             disabled
                             style={{width: '100%', height: '32px'}} 
                             value={this.state.subGrupoTrabalhoDescricao}
                             onChange={e => this.setState({subGrupoTrabalhoDescricao: e.target.value})}
                             className="p-inputtext-sm p-d-block p-mb-1"/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <MultiSelect inputId="multiselect" 
                                value={this.state.responsaveisLista} 
                                options={this.state.responsaveis} 
                                style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                onChange={(e) => this.setState({ responsaveisLista: e.value })} 
                                filter showClear filterBy="nome"
                                optionLabel="nome" 
                                placeholder="Responsáveis"/>
                  <label className="linkCadGrupo">{this.state.quantidadeResponsaveis}</label>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <MultiSelect inputId="multiselect" 
                                value={this.state.interessadosLista} 
                                options={this.state.interessados} 
                                style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                onChange={(e) => this.setState({ interessadosLista: e.value })}  
                                filter showClear filterBy="nome"
                                optionLabel="nome" 
                                placeholder="Interssados"/>
                  <label className="linkCadGrupo">{this.state.quantidadeInteressados}</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <Calendar id="mask" 
                            value={this.state.dtLimite} 
                            onChange={(e) => this.setState({ dtLimite: e.value })} 
                            locale="es"
                            style={{width: '100%', height: '32px'}} 
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            placeholder="Data Limite"/>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                <InputMask id="hora" style={{width: '100%', height: '32px'}}
                            type="text"
                            mask="99:99"
                            value={this.state.hora}
                            onChange={e => this.setState({hora: e.target.value})}
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <Calendar id="mask" 
                            value={this.state.dtFatal} 
                            onChange={(e) => this.setState({ dtFatal: e.value })} 
                            locale="es"
                            style={{width: '100%', height: '32px'}} 
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            placeholder="Prazo fatal"/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <InputTextarea value={this.state.descricao} style={{width: '100%'}}
                                  id="descricaoE"
                                  onChange={e => this.setState({descricao: e.target.value})}
                                  rows={4} 
                                  cols={60} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <Dropdown value={this.state.status} style={{width: '100%', height: '32px'}} 
                            options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                            optionLabel="status" 
                            emptyMessage=" "
                            filter showClear filterBy="status"
                            onChange={this.onChangeStatusAtividade}
                            id="idStatusAtividade"
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                </div>
              </div>
            </div>
            <br></br>
            <div className="row" style={{marginLeft: '12px'}}>
              <div className="col-sm-8">
                <div className="form-group">
                  <label htmlFor="importanteNao">
                    <Checkbox inputId="importante" 
                              name="importante" 
                              value="importante"
                              onChange={this.onGrauChange} 
                              checked={this.state.grau.indexOf('importante') !== -1} />
                    &nbsp;&nbsp;
                    Importante
                    &nbsp;&nbsp;
                    <Checkbox inputId="urgente" 
                              name="urgente" 
                              value="urgente" 
                              onChange={this.onGrauChange} 
                              checked={this.state.grau.indexOf('urgente') !== -1} />
                    &nbsp;&nbsp;
                    Urgente
                    &nbsp;&nbsp;
                    <Checkbox inputId="privado" 
                              name="privado" 
                              value="privado" 
                              onChange={this.onGrauChange} 
                              checked={this.state.grau.indexOf('privado') !== -1} />
                    &nbsp;&nbsp;
                    Privado
                  </label>
                </div>
              </div>
            </div>
          </Dialog>
        {/**Histórico de Atividades */}
        <Dialog header="Histórico da Atividade" autoComplete="nope"
                style={{ height: '50vw', width: '25vw' }} 
                visible={this.state.displayHistorico} 
                footer={
                  <frameElement>
                    <Button label="Incluir" 
                            className="p-button-primary p-button-text"
                            onClick={this.novoHistorico}/>
                    &nbsp;
                    <Button label="Fechar" 
                            className="p-button-secondary p-button-text"
                            onClick={() => this.fecharModalAtividade('displayHistorico')}/>
                  </frameElement>
                  
                } 
                onHide={() => this.fecharModalAtividade('displayHistorico')}>
            <DataView value={this.state.historico}
                      layout={this.state.layout}
                      emptyMessage=" "
                      itemTemplate={this.templateHistoricoAtividade}/>

        </Dialog>
        {/**Confirmação de exclusão de Histórico */}
        <ConfirmDialog visible={this.state.visibleHistorico} 
                       onHide={() => this.setState({ visibleHistorico: false })} 
                       message="Are you sure you want to proceed?"
                       header="Confirmation"
                       icon="pi pi-exclamation-triangle" 
                       accept={() => this.excluirHistorico} 
                       reject={() => this.setState({visibleHistorico: false})}/>
        
        {/**Incluir um novo histórico */}
        <Dialog header="Incluir Histórico" autoComplete="nope"
                style={{ width: '40vw' }} 
                visible={this.state.displayHistoricoIncluir} 
                footer={
                  <frameElement>
                    <Button label="Incluir" 
                            className="p-button-primary p-button-text"
                            onClick={() => this.incluirHistorico()}/>
                    &nbsp;
                    <Button label="Fechar" 
                            className="p-button-secondary p-button-text"
                            onClick={() => this.fecharModalAtividade('displayHistoricoIncluir')}/>
                  </frameElement>
                  
                } 
                onHide={() => this.fecharModalAtividade('displayHistoricoIncluir')}> 

          <div className="row" style={{display: `${exibieDataHistorico}`}}>
            <div className="col-sm-12">
              <div className="form-group">
              <Checkbox inputId="mudancaData" 
                        name="mudancaData" 
                        value="mudancaData" 
                        onChange={this.onMudancaData} 
                        checked={this.state.mudancaDataHistorico.indexOf('mudancaData') !== -1} />
                &nbsp;
                Mudança de Data
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <InputTextarea id="historico" 
                                type="text" 
                                autoComplete="nope"
                                style={{width: '100%'}} 
                                value={this.state.dsHistorico}
                                onChange={e => this.setState({dsHistorico: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"
                                rows={6} cols={30}/>
              </div>
            </div>
          </div>  
        </Dialog>
        {/**Descrição da Atividade */}
        <Dialog header="Descrição da Atividade"
                style={{ width: '50vw' }} 
                visible={this.state.displayDescricao} 
                footer={
                  <frameElement>
                    <Button label="Salvar" 
                            className="p-button-secondary p-button-text"
                            onClick={() => this.fecharModalAtividade('displayDescricao')}/>
                  </frameElement>
                  
                } 
                onHide={() => this.fecharModalAtividade('displayDescricao')}>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <InputTextarea id="idDescricao" 
                                type="text" 
                                autoComplete="nope"
                                style={{width: '100%'}} 
                                value={this.state.descricao}
                                onChange={e => this.setState({descricao: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"
                                rows={6} cols={30}/>
              </div>
            </div>
          </div>
        </Dialog>
        {/**Pesquisa de Processos */}
        <Dialog header="Busca de Processo"
                visible={this.state.displayProcesso} 
                style={{ width: '60vw' }} 
                footer={this.renderFooterProcesso('displayProcesso')} 
                onHide={() => this.fecharModalAtividade('displayProcesso')}>    

            <DataTable value={this.state.processos}  alwaysShowPaginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                      paginatorRight selectionMode="multiple">
              <Column field="pasta" header="Pasta"></Column>
              <Column field="nrProcesso" header="Processo Original"></Column>
              <Column field="nrCnj" header="Numeração Única"></Column>
              <Column field="autor" header="Autor x Réu" style={{width: '300px'}}></Column>
              <Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
              <Column body={this.acoesProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
            </DataTable>
        </Dialog>

         {/**Arquivos Anexados */}
         <Dialog header="Arquivos Anexados"
                style={{ width: '40vw' }} 
                visible={this.state.displayArquivosAnexados} 
                footer={
                  <frameElement>
                    <Button label="Fechar" 
                            className="p-button-secondary p-button-text"
                            onClick={() => this.fecharModalAtividade('displayArquivosAnexados')}/>
                  </frameElement>
                  
                } 
                onHide={() => this.fecharModalAtividade('displayArquivosAnexados')}>
            
            <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">  
                    <div className="container">
                      
                      <Upload onUpload={this.handleUpload}/>
                      {!!upLoadFiles && (
                        <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                      )}
                    
                    </div>
                  </div>
                </div>
              </div>
              <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                          emptyMessage="Nenhum Arquivo">
                <Column field="arquivo" header="Arquivo"/>
                <Column field="dsArquivo" header="Descrição"/>
                <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
              </DataTable> 
          </Dialog>   
          {/**Adicionar descrição ao arquivo */}
          <Dialog header="Descrição do Arquivo"
                  visible={this.state.modalDescricaoArquivo} 
                  style={{ width: '40vw' }} 
                  footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                  onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="descricaoArquivo">Descrição</label>
                    <InputText id="descricaoArquivo" 
                          type="text" 
                          style={{width: '100%', height: '37px'}} 
                          value={this.state.dsArquivo}
                          onChange={e => this.setState({dsArquivo: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
          </Dialog>

          {/**Alterar período da mini agenda */}
          <Dialog header="Agenda de Compromissos "
                    visible={this.state.modalAlterarMiniAgenda} 
                    style={{ width: '40vw' }} 
                    footer={
                        <div>
                
                            <Button label="Cancelar" 
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModalCadastro('modalAlterarMiniAgenda')}/>
                            &nbsp;
                            <Button label="Alterar" 
                                    className="p-button-primary p-button-text"
                                    onClick={this.alterarPeriodoMiniAgenda}/> 
                
                        </div>
                    }
                    onHide={() => this.fecharModalCadastro('modalAlterarMiniAgenda')}>

                <div className="row">
                  <div className="col-sm-8">
                    <div className="form-group">
                      <label htmlFor="mesAlterar">Mês</label>
                      <Dropdown value={this.state.mesMiniAgenda} style={{width: '100%', height: '32px'}} 
                                options={this.meses} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={e => this.setState({mesMiniAgenda: e.target.value})}
                                id="mesAlterar"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="anoAlterar">Ano</label>
                      <Dropdown value={this.state.anoMiniAgenda} style={{width: '100%', height: '32px'}} 
                                options={this.ano} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={e => this.setState({anoMiniAgenda: e.target.value})}
                                id="anoAlterar"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
            </Dialog>

        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <TabView activeIndex={this.state.tabAtivo}>
                <TabPanel header="Painel de Atividades">
                  <div className="card card-primary card-outline">
                    <div className="card-header" style={{display: 'inline'}}>
                      <h3 className="card-title">
                        <i className="fa fa-solid fa-network-wired"></i>
                        &nbsp;
                        <span> Meu Painel</span>
                        &nbsp;&nbsp;
                        <a className="cursor" title="Atualizar Painéis" onClick={this.atualizarPaineis}>
                          <i className="pi pi-refresh"></i>
                        </a>
                        &nbsp;
                        &nbsp;
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={this.state.pesquisaAtividade} size="50" 
                                      id="idFiltrar"
                                      onChange={(e) => this.setState({pesquisaAtividade: e.target.value})} 
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      autoComplete="nope"
                                      onKeyPress={event => event.key === 'Enter' && this.consultarPaineis()}
                                      style={{width: '100%', height: '32px'}} 
                                      placeholder="Filtrar Atividades" />
                        </span>
                        &nbsp;
                        &nbsp;
                        <span className="p-input-icon-left">
                          <label htmlFor="push3">
                            <Checkbox inputId="importante" 
                                      name="importante" 
                                      value="importante" 
                                      onChange={this.onImportante} 
                                      checked={this.state.grauFiltro.indexOf('importante') !== -1} />
                            &nbsp;
                            Importante
                            &nbsp;
                            <Checkbox inputId="urgente" 
                                      name="urgente" 
                                      value="urgente" 
                                      onChange={this.onImportante} 
                                      checked={this.state.grauFiltro.indexOf('urgente') !== -1} />
                            &nbsp;
                            Urgente
                            &nbsp;
                            <Checkbox inputId="fatal" 
                                      name="fatal" 
                                      value="fatal" 
                                      onChange={this.onImportante} 
                                      checked={this.state.grauFiltro.indexOf('fatal') !== -1} />
                            &nbsp;
                            Prazos Fatais
                          </label>
                        </span>
                      </h3>
                      <div style={{display: 'inline', paddingTop: '10px', 
                                   fontWeight: 'bold', 
                                   color: 'blue',
                                   fontSize: '12px', display: `${this.state.exibeOcorrenciasEncontradas}`}}>
                        &nbsp;
                        &nbsp;
                        {this.state.ocorrenciasEncontradas}
                      </div> 
                    </div>
                    <Backdrop
                      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                      open={this.state.openSpinner}>
                      <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                    </Backdrop>
                    
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="cardMiniAgenda">
                                <div className="card-header-MiniAgenda">
                                  <i className="fa fa-light fa-user-check" />
                                  <span> Atribuídas a mim ({this.state.quantidadeTotalResponsavel})</span>
                                </div>
                                <div className="card-content-MiniAgenda">
                                  <div>
                                    <Accordion multiple>
                                      <AccordionTab header={
                                        <frameElement>
                                          <div>
                                            <div>Atrasadas (<strong>{this.state.quantidadeAtividadesAtrasadas})</strong></div>
                                          </div>
                                        </frameElement>
                                      }>
                                        <div className="dataview-demo">
                                          <DataView value={this.state.atividadesAtrasadasResponsavelList}
                                                    layout={this.state.layout}
                                                    emptyMessage=" "
                                                    itemTemplate={this.template}/>
                                        </div>
                                      </AccordionTab>
                                      <AccordionTab header={
                                        <frameElement>
                                          <div>
                                            <div>Hoje (<strong>{this.state.quantidadeAtividadesHoje})</strong></div>
                                          </div>
                                        </frameElement>
                                      }>
                                        <div className="dataview-demo">
                                          <DataView value={this.state.atividadesHojeResponsavelList}
                                            layout={this.state.layout}
                                            emptyMessage=" "
                                            itemTemplate={this.template}/>
                                        </div>
                                      </AccordionTab>
                                      <AccordionTab header={
                                        <frameElement>
                                          <div>
                                            <div>Próximo 7 dias (<strong>{this.state.quantidadeAtividadesSete})</strong></div>
                                          </div>
                                        </frameElement>
                                      }>
                                        <div className="dataview-demo">
                                          <DataView value={this.state.atividadesSeteResponsavelList}
                                            layout={this.state.layout}
                                            emptyMessage=" "
                                            itemTemplate={this.template}/>
                                        </div>
                                      </AccordionTab>
                                      <AccordionTab header={
                                        <frameElement>
                                          <div>
                                            <div>Próximo 30 dias (<strong>{this.state.quantidadeAtividadesTrinta})</strong></div>
                                          </div>
                                        </frameElement>
                                      }>
                                        <div className="dataview-demo">
                                          <DataView value={this.state.atividadesTrintaResponsavelList}
                                            layout={this.state.layout}
                                            emptyMessage=" "
                                            itemTemplate={this.template}/>
                                        </div>
                                      </AccordionTab>
                                    </Accordion>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div class="cardMiniAgenda">
                                <div class="card-header-MiniAgenda">
                                  <i className="fa fa-duotone fa-users"></i>
                                  <span> Meus interesses ({this.state.quantidadeTotalInteressados})</span>
                                </div>
                                <div class="card-content-MiniAgenda">
                                  <div> 
                                    <Accordion multiple>
                                      <AccordionTab header={
                                        <frameElement>
                                          <div>
                                            <div>Atrasadas (<strong>{this.state.quantidadeAtrasadosInteressados})</strong></div>
                                          </div>
                                        </frameElement>
                                      }>
                                        <DataView value={this.state.atividadesAtrasadasInteressadosList}
                                          layout={this.state.layout}
                                          emptyMessage=" "
                                          itemTemplate={this.template}/>
                                      </AccordionTab>
                                      <AccordionTab header={
                                        <frameElement>
                                          <div>
                                            <div>Hoje (<strong>{this.state.quantidadeHojeInteressados})</strong></div>
                                          </div>
                                        </frameElement>
                                      }>
                                        <DataView value={this.state.atividadesHojeInteressadosList}
                                          layout={this.state.layout}
                                          emptyMessage=" "
                                          itemTemplate={this.template}/>
                                      </AccordionTab>
                                      <AccordionTab header={
                                        <frameElement>
                                          <div>
                                            <div>Próximos 7 dias (<strong>{this.state.quantidadeSeteInteressados})</strong></div>
                                          </div>
                                        </frameElement>
                                      }>
                                        <DataView value={this.state.atividadesSeteInteressadosList}
                                          layout={this.state.layout}
                                          emptyMessage=" "
                                          itemTemplate={this.template}/>
                                      </AccordionTab>
                                      <AccordionTab header={
                                        <frameElement>
                                          <div>
                                            <div>Próximos 30 dias (<strong>{this.state.quantidadeTrintaInteressados})</strong></div>
                                          </div>
                                        </frameElement>
                                      }>
                                        <DataView value={this.state.atividadesTrintaInteressadosList}
                                          layout={this.state.layout}
                                          emptyMessage=" "
                                          itemTemplate={this.template}/>
                                      </AccordionTab>
                                    </Accordion>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div class="cardMiniAgenda" style={{height: '284px'}}>
                                <div class="card-header-MiniAgenda">
                                  <span>Atividades</span>
                                </div>
                                <div class="card-content-MiniAgenda">
                                  <div> 
                                    <Chart height="200%" type="pie" data={this.state.graficoStatusData} options={this.horizontalOptions}/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <br></br>
                          <div className="row">
                            <div className="col-sm-8">
                              <div className="cardMiniAgenda">
                                <div className="card-header-MiniAgenda">
                                  <span>Score</span>
                                </div>
                                <div className="card-content-MiniAgenda">
                                  <div>
                                      <Chart style={{height: "297px"}} type="line" data={this.state.desempenhoUsuario} options={this.state.optionsChart} />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="cardMiniAgenda">
                                <div className="card-content-MiniAgenda" style={{height: "380px"}}>
                                  <div className="custom-calendar-container">
                                    <FullCalendar
                                        plugins={[dayGridPlugin, interactionPlugin, timegridPlugin]}
                                        initialView="dayGridMonth"
                                        selectable={true}
                                        locales={[ptBrLocale]}
                                        selectMirror={true}
                                        events={this.state.agenda}
                                        className="custom-calendar"
                                        height="90%"
                                        width="100%"
                                        headerToolbar={{
                                          start: 'prev,next',
                                          center: 'title',
                                          end: ''
                                      }}
                                        eventClick={this.exibirAtividades}/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>            
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="cardMiniAgenda">
                                <div className="card-header-MiniAgenda2">
                                  <Button label="Filrar" 
                                          title="Filtrar Atividades"
                                          className="p-button-primary p-button-text"
                                          onClick={this.filtrarAtividades}/>
                                  &nbsp;
                                  <Button label="Limpar Consulta" 
                                          title="Limpar Consulta"
                                          className="p-button-secondary p-button-text"
                                          onClick={this.limparConsultaAtividades}/>
                                </div>
                                <div className="card-content-MiniAgenda">
                                  <div>
                                    <DataTable value={this.state.atividadesLista}  
                                          alwaysShowPaginator responsiveLayout="scroll"
                                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" 
                                          rows={10} 
                                          emptyMessage=" "
                                          paginatorRight selectionMode="multiple">
                                      <Column body={this.statusTemplate} exportable={false} style={{ minWidth: '18rem' }} header="Status"/>
                                      <Column body={this.acoesAtividadeConsultaCalendario} exportable={false} style={{ minWidth: '8rem' }}header="Atividade"></Column>
                                      <Column body={this.faseTemplate} exportable={false} style={{ minWidth: '8rem' }} header="Fase Processual"/>
                                      <Column field="subGrupo" header="Sub-Grupo"></Column>
                                      <Column field="grupo" header="Grupo"></Column>
                                      <Column field="dataLimite" header="Data Limite"></Column>
                                      <Column body={this.prazoFatal} exportable={false} style={{ minWidth: '8rem' }}header="Prazo Fatal"></Column>
                                      <Column field="dataConcluido" header="Data Concluído"></Column>
                                      <Column body={this.acoesAtividadeConsultaCalendarioProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Processo"></Column>
                                      <Column field="partes" header="Partes"></Column>
                                    </DataTable>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </TabPanel>
                    <TabPanel header="Painel Kanban" onTa>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <MultiSelect inputId="idGrupos" 
                                        value={this.state.selectGruposKanban}
                                        options={this.state.gruposKanban} 
                                        style={{width: '100%', height: '32px'}}
                                        onChange={(e) => this.setState({ selectGruposKanban: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <MultiSelect inputId="idGrupos" 
                                        value={this.state.selectUsuariosKanban}
                                        options={this.state.usuariosKanban} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({ selectUsuariosKanban: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dataKanbanInicial} 
                                      onChange={(e) => this.setState({ dataKanbanInicial: e.value })} 
                                      locale="es"
                                      style={{width: '45%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Data Inicial"
                                      mask="99/99/9999"/>
                            &nbsp;
                            <Calendar id="mask" 
                                      value={this.state.dataKanbanFinal} 
                                      onChange={(e) => this.setState({ dataKanbanFinal: e.value })} 
                                      locale="es"
                                      style={{width: '45%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Data Final"
                                      mask="99/99/9999"/>
                          </div>
                        </div>    
                        <div className="col-sm-1">
                          <div className="form-group">
                            <Button style={{height: '32px'}} type="button" className="p-button-secondary p-button-text p-button-sm" 
                                onClick={this.consultarKanban}>
                            <i className="pi pi-filter"></i> &nbsp;&nbsp;Filtrar</Button>
                          </div>
                        </div>
                      </div>
              
                      <div style={{display: 'inline', paddingTop: '10px', fontWeight: 'bold', fontSize: '12px', display: `${this.state.exibeOcorrenciasEncontradas}`}}>
                        &nbsp;
                        &nbsp;
                        {this.state.ocorrenciasEncontradas}
                      </div> 
                      
                      <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={this.state.openSpinner}>
                        <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                      </Backdrop>
                      <br></br>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <Accordion activeIndex={0}>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>{this.state.kanbanCriadaLabel} - ({this.state.totalCriada})</div>
                                  </div>
                                </frameElement>
                              }>
                                <div className="dataview-demo">
                                  <DataView value={this.state.kanbanCriada}
                                    layout={this.state.layout}
                                    emptyMessage=" "
                                    itemTemplate={this.templateKanban}/>
                                </div>
                              </AccordionTab>
                            </Accordion>
                         </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <Accordion activeIndex={0}>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>{this.state.kanbanAtivoLabel} - ({this.state.totalAtivos})</div>
                                  </div>
                                </frameElement>
                              }>
                                <div className="dataview-demo">
                                  <DataView value={this.state.kanbanAtivo}
                                    layout={this.state.layout}
                                    emptyMessage=" "
                                    itemTemplate={this.templateKanban}/>
                                </div>
                              </AccordionTab>
                            </Accordion>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <Accordion activeIndex={0}>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>{this.state.kanbanFazendoLabel} - ({this.state.totalFazendo})</div>
                                  </div>
                                </frameElement>
                              }>
                                <div className="dataview-demo">
                                  <DataView value={this.state.kanbanFazendo}
                                    layout={this.state.layout}
                                    emptyMessage=" "
                                    itemTemplate={this.templateKanban}/>
                                </div>
                              </AccordionTab>
                            </Accordion>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <Accordion activeIndex={0}>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>{this.state.kanbanConcluidoLabel}</div>
                                  </div>
                                </frameElement>
                              }>
                                <div className="dataview-demo">
                                  <DataView value={this.state.kanbanConcluido}
                                    layout={this.state.layout}
                                    emptyMessage=" "
                                    itemTemplate={this.templateKanban}/>
                                </div>
                              </AccordionTab>
                            </Accordion>
                          </div>
                        </div>
                      </div>
                  </TabPanel>
                </TabView>
                {/**Filtro da Mini Agenda */}
                <Dialog header="Consulta de Atividades"
                        style={{ width: '40vw' }} 
                        visible={this.state.modalFiltroAtividades} 
                        footer={
                          <frameElement>
                            <Button label="Consultar" 
                                    className="p-button-primary p-button-text"
                                    onClick={this.consultarAtividadesGeral}/>
                            &nbsp;
                            <Button label="Limpar Consulta" 
                                    className="p-button-secondary p-button-text"
                                    onClick={this.limparConsultaAtividades}/>
                            &nbsp;
                            <Button label="Fechar" 
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModalAtividade('modalFiltroAtividades')}/>
                          </frameElement>
                          
                        } 
                        onHide={() => this.fecharModalAtividade('modalFiltroAtividades')}>
                    
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">  
                            <Calendar id="mask" 
                                      value={this.state.dataLimiteInicialMiniAgenda} 
                                      onChange={(e) => this.setState({ dataLimiteInicialMiniAgenda: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">  
                            <Calendar id="mask" 
                                      value={this.state.dataLimiteFinalMiniAgenda} 
                                      onChange={(e) => this.setState({ dataLimiteFinalMiniAgenda: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">  
                            <Calendar id="mask" 
                                      value={this.state.prazoFatalInicialMiniAgenda} 
                                      onChange={(e) => this.setState({ prazoFatalInicialMiniAgenda: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo Fatal"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">  
                            <Calendar id="mask" 
                                      value={this.state.prazoFatalFinalMiniAgenda} 
                                      onChange={(e) => this.setState({ prazoFatalFinalMiniAgenda: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo Fatal"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">  
                            <Calendar id="idDataConclusaoInicial" 
                                      value={this.state.dataConclusaoInicialMiniAgenda} 
                                      onChange={(e) => this.setState({ dataConclusaoInicialMiniAgenda: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Conclusão"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">  
                            <Calendar id="idDataConclusaoFinal" 
                                      value={this.state.dataConclusaoFinalMiniAgenda} 
                                      onChange={(e) => this.setState({ dataConclusaoFinalMiniAgenda: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Conclusão"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">  
                           <InputText value={this.state.processoMiniAgenda} size="50" 
                                      id="idFiltrar"
                                      onChange={(e) => this.setState({processoMiniAgenda: e.target.value})} 
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      autoComplete="nope"
                                      style={{width: '100%', height: '32px'}} 
                                      placeholder="Processo" />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">  
                            <MultiSelect value={this.state.statusMiniAgenda}
                                         options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                                         optionLabel="status" 
                                         filter showClear filterBy="status"
                                         onChange={(e) => this.setState({statusMiniAgenda: e.value})} 
                                         id="filtroStatus"
                                         placeholder="Status"
                                         className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">  
                           <InputText value={this.state.partesMiniAgenda} size="50" 
                                      id="idPartesMiniAgenda"
                                      onChange={(e) => this.setState({partesMiniAgenda: e.target.value})} 
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      autoComplete="nope"
                                      style={{width: '100%', height: '32px'}} 
                                      placeholder="Partes" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">  
                            <Dropdown value={this.state.financeiroMiniAgenda} style={{width: '100%', height: '32px'}} 
                                      options={this.financeiro} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      emptyMessage=" "
                                      onChange={e => this.setState({financeiroMiniAgenda: e.target.value})}
                                      id="financeiro"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Financeiro"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">  
                            <Dropdown value={this.state.tipoUsuarioMiniAgenda} style={{width: '100%', height: '32px'}} 
                                      options={this.tipoUsuario} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      emptyMessage=" "
                                      onChange={e => this.setState({tipoUsuarioMiniAgenda: e.target.value})}
                                      id="tipoUsuario"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Tipo de Usuário"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.faseMiniAgenda} style={{width: '100%', height: '32px'}} 
                                      options={this.state.fases} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      emptyMessage=" "
                                      onChange={e => this.setState({faseMiniAgenda: e.target.value})}
                                      id="faseAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Fase Processual"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">  
                            <Dropdown value={this.state.prazoFatalMiniAgenda} style={{width: '100%', height: '32px'}} 
                                      options={this.prazosFatais} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={e => this.setState({prazoFatalMiniAgenda: e.target.value})}
                                      id="prazoFatalMiniAgendaFiltro"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Com prazos fatais"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.importanteMiniAgenda} style={{width: '100%', height: '32px'}} 
                                      options={this.importante} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      emptyMessage=" "
                                      onChange={e => this.setState({importanteMiniAgenda: e.target.value})}
                                      id="importante"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Importante"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">  
                            <Dropdown value={this.state.urgenteMiniAgenda} style={{width: '100%', height: '32px'}} 
                                      options={this.urgente} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      emptyMessage=" "
                                      onChange={e => this.setState({urgenteMiniAgenda: e.target.value})}
                                      id="urgente"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Urgente"/>
                          </div>
                        </div>
                      </div> 
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">  
                            <Dropdown value={this.state.classificacaoMiniAgenda} style={{width: '100%', height: '32px'}} 
                                      options={this.classificacoes} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      onChange={e => this.setState({classificacaoMiniAgenda: e.target.value})}
                                      id="classificacao"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Classificação"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">  
                            <Dropdown value={this.state.ordenacaoMiniAgenda} style={{width: '100%', height: '32px'}} 
                                      options={this.ordenacoes} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      onChange={e => this.setState({ordenacaoMiniAgenda: e.target.value})}
                                      id="faseAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Ordenação"/>
                          </div>
                        </div>
                      </div>
                  </Dialog>  
                   {/**Consulta lançamento financeiro quando a atividade for desse tipo */}
                  <Dialog header="Lançamento Financeiro"
                          style={{ width: '40vw' }} 
                          visible={this.state.modalLancamento} 
                          footer={
                            <frameElement>
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('modalLancamento')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('modalLancamento')}>
                      
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Categoria do Lançamento</label>
                              <InputText id="categoriaLancamento" 
                                         type="text" 
                                         style={{width: '100%'}} 
                                         disabled
                                         value={this.state.categoriaLancamento}
                                         onChange={e => this.setState({categoriaLancamento: e.target.value})}
                                         className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Tipo de Lançamento</label>
                              <InputText id="tipoLancamento" 
                                         type="text" 
                                         style={{width: '100%'}} 
                                         disabled
                                         value={this.state.tipoLancamento}
                                         onChange={e => this.setState({tipoLancamento: e.target.value})}
                                         className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Valor Lançamento</label>
                              <InputText id="valorLancamento" 
                                         type="text" 
                                         style={{width: '100%'}} 
                                         disabled
                                         value={this.state.valorLancamento}
                                         onChange={e => this.setState({valorLancamento: e.target.value})}
                                         className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Valor Pago</label>
                              <InputText id="valorLancamentoPaga" 
                                         type="text" 
                                         style={{width: '100%'}} 
                                         disabled
                                         value={this.state.valorLancamentoPago}
                                         onChange={e => this.setState({valorLancamentoPago: e.target.value})}
                                         className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data Pagamento</label>
                              <InputText id="dataPagamento" 
                                         type="text" 
                                         style={{width: '100%'}} 
                                         disabled
                                         value={this.state.dataPagamentoLancamento}
                                         onChange={e => this.setState({dataPagamentoLancamento: e.target.value})}
                                         className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                  </Dialog>
             </section>
          </div>
        </div>
      </>
    )
  }
}

Home.contextType = AuthContext;

export default withRouter(Home)
